<template>
    <main class="order">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="navsteps">
                        <div class="navsteps__item">
                            <div class="number">1</div>
                            <div class="descr">Розрахунок</div>
                        </div>
                        <div class="navsteps__item">
                            <div class="number">2</div>
                            <div class="descr">Вибір СК</div>
                        </div>
                        <div class="navsteps__item active">
                            <div class="number">3</div>
                            <div class="descr">Оформлення</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="orders osago">
            <div class="container">
                <div class="row flex-lg-row-reverse">
                    <div class="col-lg-4">
                        <div class="policy  policy-not-chosen">
                            <div class="title d-none d-lg-block">Параметри калькуляції</div>
                            <hr class="d-none d-lg-block">
                            <div class="specific d-none d-lg-block">
                                <b>Місце реєстрації власника ТЗ</b>
                                <p>{{  showRegistrationCity() }}</p>
                            </div>
                            <div class="specific d-none d-lg-block">
                                <b>Тип ТЗ</b>
                                <p>{{ orderData.requestData.autoCategoryType }}</p>
                            </div>
                            <div class="specific d-none d-lg-block">
                                <b>Тип реєстрації</b>
                                <p>{{ showRegistrationType() }}</p>
                            </div>
                            <div class="specific d-none d-lg-block">
                                <b>Період дії</b>
                                <p>{{ orderDateInfo.period  }}</p>
                            </div>
                            <div class="specific d-none d-lg-block">
                                <b>ТЗ використовується як таксі</b>
                                <p>{{ orderData.requestData.isTaxi ? "Так" : "Ні"  }}</p>
                            </div>
                            <div class="specific d-none d-lg-block" v-if="orderData.requestData.otkDate">
                                <b>Дата наступного ОТК</b>
                                <p>{{ showOtkDate(orderData.requestData.otkDate) }}</p>
                            </div>
                            <hr class="d-none d-lg-block">
                            <div class="specific d-none d-lg-block">
                              <b>Назва СК</b>
                              <p>{{ orderData.offer.companyName }}</p>
                            </div>
                            <div class="specific d-none d-lg-block">
                                <b>Франшиза</b>
                                <p>{{ orderData.offer.franchise }} грн</p>
                            </div>
                            <hr class="d-none d-lg-block">
                            <div class="specific d-none d-lg-block">
                              <div class="result__param param-price">
                                <div class="heading result__price">
                                  <div v-if="orderData.offer.dynamicDiscountPrice > 0 || orderData.offer.discountPrice > 0 || orderData.offer.dynamicDiscountedSum > 0" class="old">
                                    <span>{{ orderData.offer.price }} <span>грн</span></span>
                                    <b v-if="orderData.offer.dynamicDiscountedSum > 0">-{{ orderData.offer.dynamicDiscountedSum }} грн</b>
                                    <b v-else >-{{ orderData.offer.discountPercent || Math.round(((orderData.offer.price - orderData.offer.discountPrice) / orderData.offer.price) * 100) }}%</b>
                                    <i
                                          data-placement="bottom"
                                          data-toggle="tooltip"
                                          title=""
                                          class="icon question"
                                          data-original-title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки."></i>

                                  </div>
                                  <b>Загальна вартість</b>
                                  <p v-if="orderData.offer.dynamicDiscountPrice > 0 || orderData.offer.discountPrice > 0" class="price value red">{{ showDiscountPrice(orderData.offer) }} грн </p>
                                  <p v-else class="price">{{ showPrice(orderData.offer) }} грн</p>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div class="warranty">
                            <h2>Ми гарантуємо</h2>
                            <ul>
                                <li class="accurate-price">Точні та вигідні ціни</li>
                                <li class="original-insurance">Оригінальну страховку</li>
                                <li class="another-solution">Рішення будь-якого питання</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <a v-if="isFromHistory()"  href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                            Повернутися
                        </a>
                        <a  v-else href="javascript:void(0);" class="go-back" @click="backToOsagoResult()">
                            Повернутися до вибору пропозицій
                        </a>
                        <!--                        </router-link>-->
                        <h1>Оформлення страховки від {{ orderData.offer.companyName }}</h1>
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-auto">
                                <div class="fill-btn-element">
                                  <div class="icon">
                                    <button @click="fillClientData()" class="btn" style="width: 53px">
                                        <div v-if="isfillClientData"
                                             class="option-loader spinner-border"
                                             style="height: 22px; width: 22px; margin-right: 12px;"
                                             role="status">
                                        </div>
                                        <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                          <rect width="32" height="32" fill="url(#pattern3)"/>
                                          <defs>
                                            <pattern id="pattern3" patternContentUnits="objectBoundingBox" width="1" height="1">
                                              <use xlink:href="#image0_561_1706" transform="scale(0.01)"/>
                                            </pattern>
                                            <image id="image0_561_1706" width="100" height="100" xlink:href="data:image/png;base64,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"/>
                                          </defs>
                                        </svg>
                                    </button>
                                  </div>
                                  <i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Заповнення форми"></i>
                                </div>
                              </div>

                                <div class="col-12 d-flex flex-wrap align-items-center">
                                    <div class="form-check me-3">
                                        <input class="form-check-input" type="checkbox" id="carOwnerParamsForm" v-model="carOwner">
                                        <label class="form-check-label" for="carOwnerParamsForm">
                                            Власник Авто
                                        </label>
                                    </div>

                                    <div class="form-check" style="margin-left: 15px">
                                        <input class="form-check-input" type="checkbox" id="isFopParamsForm" v-model="isFop">
                                        <label class="form-check-label" for="isFopParamsForm">
                                            Чи є страхувальник ФОПом
                                        </label>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <form class="step-block">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row">
                                              <div class="col-lg-6">
                                                <div class="row">
                                                  <div class="col-12">
                                                      <h3>
                                                        <span v-if="!isModulesForDisableFields()">Введіть дані авто</span>
                                                        <span v-else-if="isArx()">Введіть дані авто <i class="icon question red" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Деякі поля для АРКС недоступні до редагування"></i></span>
                                                        <span v-else-if="isUniqa()">Введіть дані авто <i class="icon question red" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Деякі поля для Uniqa недоступні до редагування"></i></span>
                                                      </h3>
                                                  </div>
                                                  <div class="col-12">
                                                    <div class="form-group">
                                                      <div class="input-group">
                                                        <input v-if="orderData.requestData.isEuroCar"  v-model="car.number"
                                                               type="text"
                                                               :disabled="isModulesForDisableFields()"
                                                               placeholder="Номерний знак*"
                                                               :class="['form-control', 'uppercase', {invalid: (!$v.car.number.required && submitCheck) ||
                                                                  (car.number && !$v.car.number.numberValidate && !$v.car.number.numberFormatValidate) ||
                                                                  (car.number && !$v.car.number.checkHasMixedLayoutsAutoNumber)}]">
                                                        <input v-else v-model="car.number"
                                                               type="text" @change="getClientDataForUpdating()"
                                                               :disabled="isModulesForDisableFields()"
                                                               v-mask="getNumberMask()"
                                                               placeholder="Номерний знак*"
                                                               :class="['form-control', 'uppercase', {invalid: (!$v.car.number.required && submitCheck) ||
                                                                  (car.number && !$v.car.number.numberValidate && !$v.car.number.numberFormatValidate)  ||
                                                                  (car.number && !$v.car.number.checkHasMixedLayoutsAutoNumber)}]">
                                                        <div class="input-group-append">
                                                          <el-button :loading="loadingSearchCarData"  class="btn btn-input-orange icon-arrow" type="button" @click="btnIdentifyModel">
                                                           <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <rect width="20" height="20" fill="url(#pattern4)"/>
                                                            <defs>
                                                              <pattern id="pattern4" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                                <use xlink:href="#image0_15_854" transform="scale(0.01)"/>
                                                              </pattern>
                                                              <image id="image0_15_854" width="100" height="100" xlink:href="data:image/png;base64,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"/>
                                                            </defs>
                                                          </svg>

                                                          </el-button>
                                                        </div>
                                                      </div>
                                                      <small class="error"
                                                             v-if="!$v.car.number.required && submitCheck">Введіть номер</small>
                                                      <small class="error"
                                                             v-else-if="car.number && !$v.car.number.checkHasMixedLayoutsAutoNumber">Введіть номерний знак тільки латиницею або тільки кирилицею</small>
                                                      <small class="error"
                                                             v-else-if="car.number && !$v.car.number.numberValidate && $v.car.number.numberFormatValidate">Введіть коректний номер</small>
                                                      <small class="error"
                                                             v-else-if="car.number && !$v.car.number.numberFormatValidate && parseInt(orderData.requestData.registrationType) == 2">Введіть коректно формат номеру авто для тимчасової реєстрації</small>
                                                      <small class="error"
                                                             v-else-if="car.number && !$v.car.number.numberFormatValidate && parseInt(orderData.requestData.registrationType) != 2">Введіть коректно формат номеру авто</small>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-lg-6">
                                                <div class="row">
                                                  <div class="col-12 city-container-item"  >
                                                    <span :class="['insurance__euro-toggle', {'disabled': euroDisabled || isModulesForDisableFields()}]">
                                                        <input type="checkbox" id="euroCheckedParamsForm" :disabled="euroDisabled || isModulesForDisableFields()"  v-model="euroChecked" @change="euroStatus()" >
                                                        <label for="euroCheckedParamsForm">Іноземна реєстрація</label>
                                                    </span>
                                                  </div>

                                                  <div class="col-12">
                                                    <div class="form-group">
                                                      <multiselect
                                                          :class="['form-control', 'choice_city', {invalid: (!euroChecked && (!$v.cityRegistration.required || !$v.cityRegistration.isObjectValid))}, {'disabled': euroChecked}]"
                                                          v-model="cityRegistration"
                                                          :options="citiesOptions"
                                                          :disabled="euroChecked || isModulesForDisableFields()"
                                                          placeholder="Місце реєстрації власника ТЗ"
                                                          @search-change="searchCities"
                                                          @select="searchCities"
                                                          :internal-search="false"
                                                          :max-height="165"
                                                          :options-limit="300"
                                                          :allow-empty="false"
                                                          label="name_full_name_ua">
                                                      </multiselect>
                                                      <small class="error" v-if="!euroChecked && (!$v.cityRegistration.required || !$v.cityRegistration.isObjectValid)">Вкажіть місце реєстрації власника ТЗ</small>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-lg-6">
                                                <div class="form-group">
                                                  <multiselect
                                                      :class="['form-control', {invalid : isInvalid(this.carType)}]"
                                                      v-model="carType"
                                                      :options="carTypes"
                                                      :disabled="isModulesForDisableFields()"
                                                      placeholder="Тип ТЗ*"
                                                      :max-height="120"
                                                      :allow-empty="false"
                                                      label="name"></multiselect>

                                                </div>
                                              </div>
                                              <div class="col-lg-6" v-if="carTypeOptions.length !== 0">
                                                <div class="form-group">
                                                  <multiselect
                                                      :class="['form-control', {invalid : ((!$v.carTypeOption.required || !checkInvalidCartype()) && submitCheck )}]"
                                                      v-model="carTypeOption"
                                                      :options="carTypeOptions"
                                                      :max-height="120"
                                                      label="name"
                                                      :disabled="autoFillCarDataByNumber || isModulesForDisableFields()"
                                                      :allow-empty="false"
                                                      placeholder="Виберіть об'єм двигуна"
                                                      :searchable="false"></multiselect>
                                                  <small class="error" v-if="(!$v.carTypeOption.required && submitCheck )">Вкажіть параметри ТЗ</small>
                                                  <small class="error" v-if="(!checkInvalidCartype() && submitCheck )">Пільгове страхування авто з объемом більше 2500см3 заборонено</small>
                                                </div>
                                              </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                      <multiselect
                                                          v-model="brandObj"
                                                          :options="carBrands"
                                                          :disabled="isModulesForDisableFields()"
                                                          @change="getClientDataForUpdating()"
                                                          :class="['form-control', {invalid: (!$v.car.brand.required && submitCheck)}]"
                                                          :taggable="true"
                                                          @tag="addNewCar($event, 'brand')"
                                                          placeholder="Марка*"
                                                          :tag-placeholder="'Натисніть Enter, щоб додати'"
                                                          :select-label="'Натисніть Enter, щоб вибрати'"
                                                          :remove-label="'Натисніть Enter, щоб очистити'"
                                                          :no-result="'Список пуст'"
                                                          label="name"
                                                          track-by="id"
                                                      ></multiselect>
                                                        <small class="error"
                                                               v-if="!$v.car.brand.required && submitCheck">Введіть марку авто</small>
                                                        <small class="error"
                                                               v-else-if="!$v.car.brand.minLength">Введіть
                                                            коректно марку авто</small>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                      <multiselect
                                                          v-model="modelObj"
                                                          :options="carModels"
                                                          @change="getClientDataForUpdating()"
                                                          :class="['form-control', {invalid: (!$v.car.model.required && submitCheck)}]"
                                                          :taggable="true"
                                                          @tag="addNewCar($event, 'model')"
                                                          placeholder="Модель*"
                                                          :tag-placeholder="'Натисніть Enter, щоб додати'"
                                                          :select-label="'Натисніть Enter, щоб вибрати'"
                                                          :remove-label="'Натисніть Enter, щоб очистити'"
                                                          :no-result="'Список пуст'"
                                                          label="name"
                                                          track-by="id"
                                                      ></multiselect>
                                                      <small class="error"
                                                             v-if="!$v.car.model.required && submitCheck">Введіть модель авто</small>
                                                      <small class="error"
                                                             v-else-if="!$v.car.model.minLength">Введіть
                                                        коректно модель авто</small>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <input v-numeric-only v-mask="'####'" type="text" v-model="car.year"
                                                               :disabled="isModulesForDisableFields()"
                                                               placeholder="Рік випуску*" @change="getClientDataForUpdating()"
                                                               :class="['form-control',{invalid: (!$v.car.year.required && submitCheck) || (!$v.car.year.minLength) || (!$v.car.year.maxLength) || (!$v.car.year.numeric)}]">
                                                        <small class="error"
                                                               v-if="!$v.car.year.required && submitCheck">Введіть рік випуску авто</small>
                                                        <small class="error"
                                                               v-else-if="(!$v.car.year.minLength) || (!$v.car.year.maxLength) || (!$v.car.year.numeric)">
                                                            Введіть коректно рік випуску авто</small>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <input v-model="car.vin" type="text" maxlength="17"
                                                               v-mask="'MMMMMMMMMMMMMMMMM'" @change="getClientDataForUpdating()"
                                                               :disabled="car.withoutVin === true"
                                                               placeholder="VIN номер*"
                                                               :class="['form-control', 'uppercase',{invalid: ((!$v.car.vin.required) ||
                                                                checkVin ||
                                                                 (!$v.car.vin.minLength)) && submitCheck}]">
                                                        <small v-if="disableCarVinBlock()">
                                                            <div class="form-check">
                                                                <input v-model="car.withoutVin" type="checkbox" @click="disableCarVin()" class="form-check-input" id="withoutCarVin">
                                                                <label class="form-check-label" for="withoutCarVin">Невідомий VIN</label>
                                                            </div>
                                                        </small>
                                                        <div v-if="submitCheck">
                                                            <small class="error"
                                                                   v-if="!$v.car.vin.required">Введіть VIN номер авто</small>
                                                            <small class="error"
                                                                   v-else-if="! $v.car.vin.maxLength || ! $v.car.vin.minLength || checkVin">Введіть
                                                                коректно VIN номер авто</small>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="col-lg-3" v-if="!excludeModules.includes(parseInt(orderData.offer.ex_id))">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car_additional_parameters.totalWeight" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="Повна маса, кг*"
                                                         :class="['form-control',{invalid: (!$v.car_additional_parameters.totalWeight.numeric) || (!$v.car_additional_parameters.totalWeight.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car_additional_parameters.totalWeight.required && submitCheck">Введіть повну масу</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.totalWeight.numeric && submitCheck">Введіть корректно повну масу</small>
                                                </div>
                                              </div>
                                              <div class="col-lg-3" v-if="!excludeModules.includes(parseInt(orderData.offer.ex_id))">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car_additional_parameters.ownWeight" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="Маса без навантаження, кг*"
                                                         :class="['form-control',{invalid: (!$v.car_additional_parameters.ownWeight.numeric || (!$v.car_additional_parameters.ownWeight.required && submitCheck)) }]">
                                                  <small class="error"
                                                         v-if="!$v.car_additional_parameters.ownWeight.required && submitCheck">Введіть масу без навантаження</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.ownWeight.numeric && submitCheck">Введіть корректно масу без навантаження</small>
                                                </div>
                                              </div>

                                              <div v-if="carType.group == 'CAR' && carType.external_id == 'B5' && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-3">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car_additional_parameters.kvt" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="Потужність, кВт*"
                                                         :class="['form-control',{invalid: (!$v.car_additional_parameters.kvt.isDecimal) || (!$v.car_additional_parameters.kvt.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car_additional_parameters.kvt.required && submitCheck">Введіть потужність</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.kvt.isDecimal && submitCheck">Введіть корректно потужність, кВт</small>
                                                </div>
                                              </div>
                                              <div  v-else-if="!['TRAILER'].includes(carType.group) && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-3">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car_additional_parameters.capacity" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="Об'єм двигуна ТЗ в см³*"
                                                         :class="['form-control',{invalid: (!$v.car_additional_parameters.capacity.numeric) || (!$v.car_additional_parameters.capacity.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car_additional_parameters.capacity.required && submitCheck">Введіть об'єм двигуна ТЗ</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.capacity.numeric && submitCheck">Введіть корректно об'єм двигуна ТЗ</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.capacity.isWithinCapacityRange">
                                                    Об'єм має бути диапазоні {{ carTypeOption.capacity.min }} - {{ carTypeOption.capacity.max }} см³
                                                  </small>
                                                </div>
                                              </div>
                                              <div v-if="!['TRAILER'].includes(carType.group) && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-3">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car_additional_parameters.numberOfSeats" type="text" maxlength="17"
                                                         :class="['form-control',{invalid: (!$v.car_additional_parameters.numberOfSeats.numeric) || (!$v.car_additional_parameters.numberOfSeats.required && submitCheck) }]"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="К-ть місць для сидіння, з водієм"
                                                  >
                                                  <small class="error"
                                                         v-if="!$v.car_additional_parameters.numberOfSeats.required && submitCheck">Введіть кількість місць</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car_additional_parameters.numberOfSeats.numeric && submitCheck">Введіть корректно кількість місць</small>
                                                </div>
                                              </div>
                                              <div :disabled="true" v-if="showMileageFields && !['TRAILER'].includes(carType.group) && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-6">
                                               <div class="form-group">
                                                  <input v-numeric-only v-model="car.kilometers" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="Максимальний пробіг ЗТЗ*"
                                                         :class="['form-control',{invalid: (!$v.car.kilometers.numeric) || (!$v.car.kilometers.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car.kilometers.required && submitCheck">Введіть максимальний пробіг ЗТЗ</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car.kilometers.numeric && submitCheck">Введіть корректно максимальний пробіг ЗТЗ</small>
                                                </div>
                                              </div>
                                              <div v-if="showMileageFields && !['TRAILER'].includes(carType.group) && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-6">
                                                <div class="form-group">
                                                  <input v-numeric-only v-model="car.odometr" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="пробіг ЗТЗ*"
                                                         :class="['form-control',{invalid: (!$v.car.odometr.numeric) || (!$v.car.odometr.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car.odometr.required && submitCheck">Введіть пробіг ЗТЗ</small>
                                                  <small class="error"
                                                         v-else-if="!$v.car.odometr.numeric && submitCheck">Введіть корректно пробіг ЗТЗ</small>
                                                </div>
                                              </div>
                                              <div v-if="!['TRAILER'].includes(carType.group) && !excludeModules.includes(parseInt(orderData.offer.ex_id))" class="col-lg-6">
                                                <div class="form-group">
                                                  <input v-mask="'##.##.####'" v-model="car.birthdayAt" type="text" maxlength="17"
                                                         @change="getClientDataForUpdating()"
                                                         placeholder="дата народження водія*"
                                                         :disabled="isDescriptionsAgeCustomer"
                                                         :class="['form-control',{invalid: (!$v.car.birthdayAt.minYears) || (!$v.car.birthdayAt.required && submitCheck) }]">
                                                  <small class="error"
                                                         v-if="!$v.car.birthdayAt.required && submitCheck">Введіть дату народження водія</small>
                                                  <small class="error" v-else-if="!$v.car.birthdayAt.minYears && submitCheck">
                                                    Водію повинно бути більше 18 років
                                                  </small>
                                                </div>
                                              </div>
                                                <div class="col-12">
                                                    <h3>Введіть дані страхувальника</h3>
                                                </div>
                                                <div v-if="! isLegalType"  class="col-lg-6">
                                                    <div class="form-group tooltip-group inn-block">
                                                        <input  type="text" placeholder="ІПН*" v-loading="isLoadInsuredsList"
                                                                :disabled="userData.withoutIdentificationCode == true || isArx()"
                                                                v-model="userData.identificationCode"
                                                                :class="['form-control inn-field', {invalid: hasError('personal.identificationCode') || (!$v.userData.identificationCode.required && submitCheck)}]"
                                                                v-mask="'##########'" maxlength="10">
                                                        <div v-if="insuredsList && insuredsList.length > 0" class="autocomplete-inn">
                                                          <div @click="selectInsuredInfo(insured)" class="inn-items mb-1 mt-2" v-for="insured in insuredsList">
                                                                <insureds-list-item :insured="insured"></insureds-list-item>
                                                            </div>
                                                        </div>
                                                        <i v-if="! isLoadInsuredsList" data-html="true" data-toggle="tooltip" data-select="true"
                                                           title="" class="icon question"
                                                           data-original-title="<img src='https://ukasko.ua/images/tooltips/inn.png'>"></i>
                                                        <div v-else class="load-insured-list spinner-border spinner-border-sm" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <small class="error"
                                                               v-if="!$v.userData.identificationCode.required && submitCheck">Введіть ІПН</small>
                                                        <small class="error"
                                                               v-else-if="(!$v.userData.identificationCode.customMinLength && submitCheck) ||
                                                                           (!$v.userData.identificationCode.numeric && submitCheck)">
                                                            Введіть коректно ІПН
                                                        </small>
                                                        <small class="error" v-else-if="errorTaxNumber">
                                                            ІПН та Дата народження не співпадають
                                                        </small>

                                                        <small v-if="disableIdentificationCodeBlock() && ! isArx()">
                                                            <div class="form-check">
                                                                <input v-model="userData.withoutIdentificationCode" type="checkbox"
                                                                       @click="disableIdentificationCode()"
                                                                       class="form-check-input" id="withoutIdentificationCode">
                                                                <label class="form-check-label" for="withoutIdentificationCode">Відсутній ІПН</label>
                                                            </div>
                                                        </small>
                                                    </div>
                                                </div>
                                                <div v-if="! isLegalType" class="col-lg-6">
                                                    <div class="form-group surname-block">
                                                        <input v-model="userData.surname"  v-loading="isLoadInsuredsListBySurname"
                                                               maxlength="30"
                                                               type="text"
                                                               placeholder="Прізвище*"
                                                               :class="['form-control surname-field',
                                                               {invalid: (!$v.userData.surname.required && submitCheck) || (!$v.userData.surname.minLength) || (!$v.userData.surname.maxLength)}]">
                                                        <div v-if="isLoadInsuredsListBySurname" class="load-insured-list spinner-border spinner-border-sm" role="status"></div>
                                                        <div v-if="insuredsListBySurname && insuredsListBySurname.length > 0" class="autocomplete-surname">
                                                            <div @click="selectInsuredInfo(insured)" class="inn-items mb-1 mt-2" v-for="insured in insuredsListBySurname">
                                                                <insureds-list-item :insured="insured"></insureds-list-item>
                                                            </div>
                                                        </div>
                                                        <small class="error"
                                                               v-if="!$v.userData.surname.required && submitCheck">
                                                            Введіть прізвище</small>
                                                        <small class="error"
                                                               v-else-if="! $v.userData.surname.minLength || ! $v.userData.surname.maxLength">
                                                            Введіть коректно прізвище</small>

                                                    </div>
                                                </div>
                                                <div v-if="isLegalType" class="col-lg-6">
                                                    <div class="form-group company-name-block">
                                                        <input  v-model.trim="userData.name" v-loading="isLoadInsuredsByCompanyName"  type="text" placeholder="Назва компанії*"
                                                                :class="['form-control company-name-field',{invalid: (!$v.userData.name.required && submitCheck)
                                                               || (!$v.userData.name.minLength)}]">
                                                        <div v-if="isLoadInsuredsByCompanyName" class="load-insured-list spinner-border spinner-border-sm" role="status"></div>
                                                        <div v-if="insuredsListByCompanyName && insuredsListByCompanyName.length > 0"
                                                             class="autocomplete-company-name">
                                                            <div @click="selectInsuredInfo(insured)" class="inn-items mb-1 mt-2" v-for="insured in insuredsListByCompanyName">
                                                                <insureds-list-item :is-legal-type="true" :insured="insured"></insureds-list-item>
                                                            </div>
                                                        </div>
                                                        <small class="error"
                                                               v-if="!$v.userData.name.required && submitCheck">Введіть ім'я компанії</small>
                                                        <small class="error"
                                                               v-else-if="!$v.userData.name.minLength">Введіть
                                                            коректно ім'я компанії</small>
                                                    </div>
                                                </div>
                                                <div v-if="! isLegalType" class="col-lg-6">
                                                    <div class="form-group">
                                                        <input  v-model="userData.name" @change="getClientDataForUpdating()" type="text" placeholder="Ім'я*"
                                                               :class="['form-control',{invalid: (!$v.userData.name.required && submitCheck) || (!$v.userData.name.minLength)}]">
                                                        <small class="error"
                                                               v-if="!$v.userData.name.required && submitCheck">Введіть ім'я</small>
                                                        <small class="error"
                                                               v-else-if="!$v.userData.name.minLength">Введіть коректно ім'я</small>
                                                    </div>
                                                </div>
                                                <div v-if="! isLegalType" class="col-lg-6">
                                                    <div class="form-group">
                                                        <input v-mask="getNameMask()" @change="getClientDataForUpdating()" v-on:keydown='removeSpace' v-model="userData.patronymic" type="text"
                                                            :class="['form-control',{invalid: (!$v.userData.patronymic.required && submitCheck)}]" placeholder="Ім’я по батькові">
                                                        </input>
                                                        <small class="error"
                                                               v-if="!$v.userData.patronymic.required && submitCheck">Введіть ім'я по батькові</small>
                                                    </div>
                                                </div>
                                                <div v-if="isLegalType" class="col-lg-6">
                                                    <div class="form-group tooltip-group erdpy-code-block">
                                                        <input type="text" v-loading="isLoadInsuredsByErdpyCode" placeholder="ЄДРПОУ"
                                                               v-model="userData.erdpyCode"
                                                               :class="['form-control erdpy-code-field',{invalid: (!$v.userData.erdpyCode.required && submitCheck) ||
                                                                (!$v.userData.erdpyCode.minLength) || (!$v.userData.erdpyCode.maxLength)
                                                                || (!$v.userData.erdpyCode.numeric) }]"
                                                               v-mask="'##########'" maxlength="8">
                                                        <div v-if="isLoadInsuredsByErdpyCode" class="load-insured-list spinner-border spinner-border-sm" role="status">
                                                        </div>
                                                        <div v-if="insuredsListByErdpyCode && insuredsListByErdpyCode.length > 0"
                                                             class="autocomplete-erdpy-code">
                                                            <div @click="selectInsuredInfo(insured)" class="inn-items mb-1 mt-2" v-for="insured in insuredsListByErdpyCode">
                                                                <insureds-list-item :is-legal-type="true" :insured="insured"></insureds-list-item>
                                                            </div>
                                                        </div>
                                                        <small class="error"
                                                               v-if="!$v.userData.erdpyCode.required && submitCheck">Введіть ЄДРПОУ</small>
                                                        <small class="error"
                                                               v-else-if="(!$v.userData.erdpyCode.minLength) ||
                                                                          (!$v.userData.erdpyCode.maxLength) ||
                                                                          (!$v.userData.erdpyCode.numeric)">Введіть коректно ЄДРПОУ</small>
                                                        <small class="invalid-feedback error"
                                                               v-else-if="hasError('personal.erdpyCode')"
                                                               v-html="getError('personal.erdpyCode')"></small>
                                                    </div>
                                                </div>
                                                <div v-if="!isLegalType" class="col-lg-6">
                                                    <div class="form-group">
                                                        <input v-mask="'##.##.####'" placeholder="Дата народження*"
                                                               v-model="userData.dateBirth" @change="getClientDataForUpdating()"
                                                               :class="['form-control', 'form-input_date', {invalid: (!$v.userData.dateBirth.required && submitCheck) ||
                                                                (!$v.userData.dateBirth.minLength) ||
                                                                 (!$v.userData.dateBirth.maxLength) ||
                                                                 (!$v.userData.dateBirth.minYears) ||
                                                                 (!$v.userData.dateBirth.minMonth) ||
                                                                  (errorBirthDate || hasError('personal.errorBirthDate'))}]">
                                                        <small class="error"
                                                               v-if="!$v.userData.dateBirth.required && submitCheck">Введіть дату народження</small>
                                                        <small class="error"
                                                               v-else-if="(!$v.userData.dateBirth.minLength) || (!$v.userData.dateBirth.maxLength) || !$v.userData.dateBirth.daysInMonth">
                                                            Введіть коректну дату народження</small>
                                                        <small class="error" v-else-if="!$v.userData.dateBirth.minYears || !$v.userData.dateBirth.minMonth">
                                                            Страхувальнику повинно бути більше 18 років
                                                        </small>
                                                        <small class="invalid-feedback error" v-else-if="hasError('personal.dateBirth')" v-html="getError('personal.dateBirth')"></small>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                  <div class="form-group">
                                                    <multiselect
                                                        :class="['form-control', 'choice_userData_address_city', {invalid: ((!$v.cityСlient.required || !$v.cityСlient.isObjectValid) && submitCheck)}]"
                                                        v-model="cityСlient"
                                                        :options="citiesСlientOptions"
                                                        placeholder="Місто*"
                                                        @search-change="searchClientCities"
                                                        @select="selectClientCities"
                                                        :internal-search="false"
                                                        :max-height="165"
                                                        :options-limit="300"
                                                        :allow-empty="false"
                                                        label="name_full_name_ua">
                                                    </multiselect>
                                                    <small class="error" v-if="(!$v.cityСlient.required || !$v.cityСlient.isObjectValid) && submitCheck">Вкажіть місто</small>
                                                  </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <input v-model="userData.address.street" type="text" @change="getClientDataForUpdating()"
                                                               placeholder="Вулиця*"
                                                               :class="['form-control',{invalid: (!$v.userData.address.street.required && submitCheck) ||
                                                                                                 (!$v.userData.address.street.minLength)}]">
                                                        <small class="error"
                                                               v-if="!$v.userData.address.street.required && submitCheck">Введіть вулицю</small>
                                                        <small class="error"
                                                               v-else-if="!$v.userData.address.street.minLength">Введіть коректно вулицю</small>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                  <div class="row">
                                                    <div class="col-lg-6">
                                                      <div class="form-group">
                                                        <input v-model="userData.address.house" type="text" @change="getClientDataForUpdating()"
                                                               placeholder="Номер будинку*"
                                                               :class="['form-control',{invalid: !$v.userData.address.house.required && submitCheck}]">
                                                        <small class="error"
                                                               v-if="!$v.userData.address.house.required && submitCheck">
                                                          Введіть номер будинку</small>
                                                      </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                      <div class="form-group">
                                                        <input v-model="userData.address.number" type="text" @change="getClientDataForUpdating()"
                                                               placeholder="Номер квартири" class="form-control">
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-lg-6">
                                                  <div class="form-group">
                                                    <input v-mask="'+38 (###) ###-##-##'" v-model="userData.phone" @change="getClientDataForUpdating()"
                                                           placeholder="Телефон*"
                                                           :class="['form-control',{invalid: (!$v.userData.phone.required && submitCheck) ||
                                                                 (!$v.userData.phone.minLength && submitCheck) ||
                                                                 (!$v.userData.phone.maxLength)}]">
                                                    <small class="error"
                                                           v-if="!$v.userData.phone.required && submitCheck">Введіть телефон</small>
                                                    <small class="error"
                                                           v-else-if="(!$v.userData.phone.minLength && submitCheck) || (!$v.userData.phone.maxLength)">
                                                      Введіть коректно телефон</small>
                                                  </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <input type="text" v-model.trim="userData.email" @change="getClientDataForUpdating()"
                                                               placeholder="Email на який отримаєте поліс*"
                                                               :class="['form-control',{invalid: (!$v.userData.email.required && submitCheck) ||
                                                                (!$v.userData.email.email)}]">
                                                        <small class="error"
                                                               v-if="!$v.userData.email.required && submitCheck">Введіть email</small>
                                                        <small class="error"
                                                               v-else-if="!$v.userData.email.email">Введіть коректно email</small>
                                                    </div>
                                                </div>
                                                <div v-if="isLegalType" class="col-lg-6">
                                                  <div class="form-group">
                                                    <input type="text" v-model.trim="userData.signerFullName" @change="getClientDataForUpdating()"
                                                           placeholder="ПІБ підписанта договору*"
                                                           :class="['form-control',{invalid: (!$v.userData.signerFullName.required && submitCheck) ||
                                                                (!$v.userData.signerFullName)}]">
                                                    <small class="error"
                                                           v-if="!$v.userData.signerFullName.required && submitCheck">ПІБ підписанта договору</small>
                                                  </div>
                                                </div>
                                            </div>
                                            <DocumentsBlock
                                                ref="documentsBlock"
                                                :productType="1"
                                                :offerInfo="orderData.offer"
                                                :searchInfo="orderData.requestData"
                                                :documentation="userData.documentation"
                                                :submitCheck="submitCheck"
                                                @data-chenged="getClientDataForUpdating"
                                                :withoutIdentificationCode="userData.withoutIdentificationCode"
                                                :dateBirth="userData.dateBirth"
                                                :privileges="!requiresPrivilegeDocument"
                                            ></DocumentsBlock>

                                            <DocumentsBlock v-if="requiresPrivilegeDocument"
                                                ref="documentsBlockPrivileges"
                                                :productType="1"
                                                :offerInfo="orderData.offer"
                                                :searchInfo="orderData.requestData"
                                                :documentation="userData.privilege"
                                                :submitCheck="submitCheck"
                                                @data-chenged="getClientDataForUpdating"
                                                :withoutIdentificationCode="userData.withoutIdentificationCode"
                                                :dateBirth="userData.dateBirth"
                                            ></DocumentsBlock>

                                            <div class="row">
                                                <div class="col-lg-6 text-center form-group">
                                                    <button v-on:click="nextStep()" :disabled="!checkYearOwner && isModulesForDisableFields()" type="button" class="btn btn-blue">
                                                        Перейти до наступного кроку
                                                    </button>
                                                  <small class="error"
                                                         v-if="!checkYearOwner && isModulesForDisableFields()">Рік народження власника відрізняється від отриманой від МТСБУ</small>
                                                </div>
                                                <div class="col-lg-6 text-center">
                                                    <button v-on:click="saveDraft()" type="button" class="btn btn-outline-secondary">
                                                        Зберегти чернетку
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div></div>
                        <div class="order-memo">
                            <div class="order-memo__wrapp row">
                                <div class="order-memo__content col-md-6">
                                    <div class="order-memo__heading">
                                        <h3>Що робити при страховому випадку?</h3>
                                    </div>
                                    <a target="_blank" href="https://ukasko.ua/images/guarantee/General_Rules_ua.pdf" download=""
                                       class="order-memo__link link-desk btn-blue btn download_General_Rules_ru">
                                        Завантажити пам'ятку</a> <a href="https://ukasko.ua/images/guarantee/General_Rules_ua.pdf"
                                                                    target="_blank"
                                                                    class="order-memo__link link-mob btn-blue btn download_General_Rules_ru">
                                    Дивитися пам'ятку</a>
                                </div>
                                <div class="order-memo__img col-md-6"><img
                                    src="https://ukasko.ua/images/guarantee/104.svg"><img></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <custom-alert :message="alertMessage" popupId="orderSteps" @close="onAlertClose" />
      <popup-compinate-plate ref="modalCompinatePlate"></popup-compinate-plate>
      <popup-preloader></popup-preloader>
      <clients-fill-data-func :show-fill-client-data-modal="showFillClientDataModal" :clien-data="selectedPibInn" :search-info="orderData.requestData" :offer-info="orderData.offer" :product-type="productType" @close="showFillClientDataModal = false" @save="saveFillData"/>
    </main>
</template>


<script>

import { PRIVILEGE_REQUIRED_MODULES } from '@/shared/config/insurance-modules';
import Multiselect from 'vue-multiselect';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import { email, maxLength, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators';
import {
  autoNumberValidate,
  CheckVehicleCalculateAndStepsMixin,
  companyMixin,
  customerMixin,
  documentMixin
} from '../mixin';
import { getData, saveClient } from '@/api/client';
import { getMark } from '@/api/dictionary';
import { saveOrder } from '@/api/order';
import ClientsFillDataFunc from '@/components/app/clients/clientsFillDataFunc';
import DocumentsBlock from '@/components/app/forms/DocumentsBlock.vue';
import CustomAlert from '@/components/app/modals/CustomAlert.vue';
import PopupCompinatePlate from '@/components/app/modals/PopupCompinatePlate.vue';
import PopupPreloader from '@/components/app/modals/PopupPreloader.vue';
import { InsuredsListItem } from '@/views/osago/components';

export default {
  mixins: [
    customerMixin,
    companyMixin,
    documentMixin,
    CheckVehicleCalculateAndStepsMixin,
    autoNumberValidate
  ],
  components: {
    ClientsFillDataFunc,
    CustomAlert,
    Multiselect,
    InsuredsListItem,
    VueTypeaheadBootstrap,
    DocumentsBlock,
    PopupPreloader,
    PopupCompinatePlate,
    getData,
  },
  data: function () {
    return {
      //TODO подбные значения вынести бы в какой то список "технических" переменных или переменных состояний.
      //А эти две переменные вообще тут бы не должны быть. Так как этот кастомный автокомлид, можно было бы перенести в один полноценный плагин
      isLoadInsuredsList: false,
      autoFillCarDataByNumber: false,
      fetchClientsTimeout: null,
      selectedPibInn: false,
      checkYearOwner: false,
      productType: 'osago',
      isLoadInsuredsListBySurname: false,
      isLoadInsuredsByErdpyCode: false,
      isLoadInsuredsByCompanyName: false,
      showFillClientDataModal: false,
      isfillClientData: false,
      isfillData: false,
      descriptions: [],
      descriptionsAgeCustomer: [],
      cities: null,
      clientId: null,
      alertMessage: '',
      parentOrderId: null,
      prolongOrderId: null,
      orderId: null,
      hideCarVin: false,
      isLegalType: false,
      changedCity: false,
      loadingSearchCarData: false,
      typeDocument: null,
      brandObj: null,
      fillDataAutoComplit: false,
      modelObj: null,
      privilegeList: [],
      insuredsList: [],
      insuredsListBySurname: [],
      insuredsListByErdpyCode: [],
      insuredsListByCompanyName: [],
      typeDocumentId: null,
      cityRegistration: null,
      cityСlient: null,
      euroDisabled: false,
      carOwner: true,
      isFop: false,
      euroChecked: false,
      showMileageFields: false,
      autoNumberValidatePatternGroup:['vehicle','trailer','vr','mvs','diplomatic','military'],
      otherVariants: [{ id:0,name:'іншій країні',name_full_name_ua:'ТС зареєстровано в іншій країні',zone:0 }],
      //TODO это нужно вынести в storage. И все подобные моменты по проекту
      citiesOptions: [ { 'id': 1,'name': 'Київ','name_full_name_ua': 'м. Київ, Україна', 'zone':1 },
        { 'id': 9,'name': 'Дніпро','name_full_name_ua': 'м. Дніпро, Дніпропетровська  обл., Україна', 'zone':2 },
        { 'id': 11,'name': 'Львів','name_full_name_ua': 'м. Львів, Львівська  обл., Україна', 'zone':1 },
        { 'id': 13,'name': 'Одеса','name_full_name_ua': 'м. Одеса, Одеська  обл., Україна', 'zone':2 },
        { 'id': 14,'name': 'Харків','name_full_name_ua': 'м. Харків, Харківська  обл., Україна', 'zone':2 },
        { 'id': 16,'name': 'Запоріжжя','name_full_name_ua': 'м. Запоріжжя, Запорізька  обл., Україна', 'zone':3 },
        { 'id': 17,'name': 'Кривий Ріг','name_full_name_ua': 'м. Кривий Ріг, Дніпропетровська  обл., Україна', 'zone':3 },
        { 'id': 21,'name': 'Вінниця','name_full_name_ua': 'м. Вінниця, Вінницька  обл., Україна', 'zone':4 },
        { 'id': 36,'name': 'Маріуполь','name_full_name_ua': 'м. Маріуполь, Донецька  обл., Україна', 'zone':4 },
        { 'id': 41,'name': 'Полтава','name_full_name_ua': 'м. Полтава, Полтавська  обл., Україна', 'zone':4 }],
      citiesСlientOptions: [ { 'id': 1,'name': 'Київ','name_full_name_ua': 'м. Київ, Україна', 'zone':1 },
        { 'id': 9,'name': 'Дніпро','name_full_name_ua': 'м. Дніпро, Дніпропетровська  обл., Україна', 'zone':2 },
        { 'id': 11,'name': 'Львів','name_full_name_ua': 'м. Львів, Львівська  обл., Україна', 'zone':1 },
        { 'id': 13,'name': 'Одеса','name_full_name_ua': 'м. Одеса, Одеська  обл., Україна', 'zone':2 },
        { 'id': 14,'name': 'Харків','name_full_name_ua': 'м. Харків, Харківська  обл., Україна', 'zone':2 },
        { 'id': 16,'name': 'Запоріжжя','name_full_name_ua': 'м. Запоріжжя, Запорізька  обл., Україна', 'zone':3 },
        { 'id': 17,'name': 'Кривий Ріг','name_full_name_ua': 'м. Кривий Ріг, Дніпропетровська  обл., Україна', 'zone':3 },
        { 'id': 21,'name': 'Вінниця','name_full_name_ua': 'м. Вінниця, Вінницька  обл., Україна', 'zone':4 },
        { 'id': 36,'name': 'Маріуполь','name_full_name_ua': 'м. Маріуполь, Донецька  обл., Україна', 'zone':4 },
        { 'id': 41,'name': 'Полтава','name_full_name_ua': 'м. Полтава, Полтавська  обл., Україна', 'zone':4 }],
      carTypeOption: { 'name':'до 1600 см3','value':'B1','auto_kind_limit':1600,'capacity':{ 'min':1,'max':1600 },'engineVolume':1600 },
      carType: { 'name':'Легкові автомобілі', 'external_id':'B1', 'group':'CAR','engine':'до 1600 см3',
        'engines':[{ 'name':'до 1600 см3','value':'B1','auto_kind_limit':1600,'capacity':{ 'min':1,'max':1600 },'engineVolume':1600 },
          { 'name':'1601-2000 см3','value':'B2','auto_kind_limit':2000,'capacity':{ 'min':1601,'max':2000 },'engineVolume':1800 },
          { 'name':'2001-3000 см3','value':'B3','auto_kind_limit':3000,'capacity':{ 'min':2001,'max':3000 },'engineVolume':2500 },
          { 'name':'более 3001 см3','value':'B4','auto_kind_limit':3500,'capacity':{ 'min':3001,'max':10000 },'engineVolume':3500 }],
        'types':[] },
      carTypes: [
        { 'name':'Легкові автомобілі','group':'CAR', 'external_id':'B1',
          'engines':[{ 'name':'до 1600 см3','capacity':{ 'min':1,'max':1600 },'value':'B1' },
            { 'name':'1601-2000 см3','capacity':{ 'min':1601,'max':2000 },'value':'B2' },
            { 'name':'2001-3000 см3','capacity':{ 'min':2001,'max':3000 },'value':'B3' },
            { 'name':'более 3001 см3','capacity':{ 'min':3001,'max':10000 },'value':'B4' }], 'types':[] },
        { 'name':'Автобус','group':'BUS','external_id':'D1', 'engines':[],
          'types':[{ 'name':'менше 20 осіб','value':'D1' },
            { 'name':'більше 20 осіб','value':'D2' }] },
        {
          'name':'Вантажні автомобілі',
          'external_id':'C1',
          'group':'CARGO',
          'engines':[],
          'types':[
            { 'name':'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)','value':'C0' },
            { 'name':'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))','value':'C1' },
            { 'name':'С2 (з вантажопідйомністю більше 2т)','value':'C2' }
          ]
        },
        { 'name':'Причіп, Трейлер','group':'TRAILER','engine':null, 'external_id':'E', 'engines':[],
          'types':[{ 'name':'До вантажного авто','value':'E' },
            { 'name':'До легкового авто','value':'F' }] },
        { 'name':'Мотоцикли та моторолери','group':'BIKE', 'external_id':'A1',
          'engines':[{ 'name':'300 см3 або менше','value':'A1' },
            { 'name':'більше 300 см3','value':'A2' }], 'types':[] },
        { 'name':'Легковий електромобіль','group':'CAR','external_id':'B5','engine':null,'engines':[],'types':[{ 'name':'Легковий електромобіль','value':'B5' }] }
      ],
      errors: {},
      carBrands:[],
      carModels:[],
      submitCheck: false,
      car_additional_parameters: {
        totalWeight: null,
        ownWeight: null,
        kvt: null,
        numberOfSeats: null,
        capacity: null,
      },
      car: {
        vin: null,
        birthDateOwner: null,
        year: null,
        brand: null,
        model: null,
        number: null,
        withoutVin: false,
        cityId: 1,
        kilometers: null,
        odometr: null,
        birthdayAt: null,
        additional_parameters:{
          capacity: null,
          ownWeight: null,
          totalWeight: null,
          kvt: null,
          numberOfSeats: null,
        }
      },
      userData: {
        name: null,
        phone: '0',
        email: null,
        surname: null,
        dateBirth: null,
        patronymic: null,
        identificationCode: null,
        withoutIdentificationCode: false,
        erdpyCode: null,
        signerFullName: null,
        documentation: {
          //TODO текущее значение нобходимо будет брать с словаря(api)
          type: 1,//'DOCUMENT_PASSPORT'
          serial: null,
          number: null,
          issuedBy: null,
          dateOfIssue: null,
          endDateOfIssue: null,
          dateOfIssueError: false,
        },
        privilege: {
          //TODO текущее значение нобходимо будет брать с словаря(api)
          type: 1,//'DOCUMENT_PASSPORT'
          serial: null,
          number: null,
          issuedBy: null,
          dateOfIssue: null,
          endDateOfIssue: null,
          dateOfIssueError: false,
        },
        address: {
          street: null,
          house: null,
          number: null,
          cityId: 1
        }
      }
    };
  },
  validations: {
    cityRegistration:{ required: requiredIf(function(){
      return !this.euroChecked;
    }),
    isObjectValid: function(value) {
      return (this.euroChecked) ? this.euroChecked : (value !== null && value.id !== null);
    } },
    cityСlient:{ required,
      isObjectValid: function(value) {
        return value !== null && value.id !== null;
      } },
    car_additional_parameters:{
      capacity: {
        required: requiredIf(function(){
          return this.carType.group == 'CAR' && this.carType.external_id != 'B5' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
        }),numeric: (value) => {
          return !value || !isNaN(parseFloat(value));
        },
        isWithinCapacityRange(value) {
          const option = this.carTypeOption;
          const capacityValue = parseFloat(value);
          if (!value || isNaN(capacityValue) || !option || !option.capacity || !['B1', 'B2', 'B3', 'B4'].includes(option.value)) {
            return true;
          }
          const minCapacity = option.capacity.min;
          const maxCapacity = option.capacity.max;
          if (capacityValue < minCapacity || capacityValue > maxCapacity) {
            return false;
          }
          return true;
        }
      },
      ownWeight: { required: requiredIf(function(){
        return !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }),numeric: (value) => {
        return !value || !isNaN(parseFloat(value));
      } },
      totalWeight: { required: requiredIf(function(){
        return !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }),numeric: (value) => {
        return !value || !isNaN(parseFloat(value));
      } },
      kvt: { required: requiredIf(function(){
        return this.carType.group == 'CAR' && this.carType.external_id == 'B5' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }), isDecimal: function(value) {
        // Проверяем, что значение является числом с точкой или запятой
        if (value === null || value === undefined || value === '') {
          return true; // Пустые значения проверяет `required`
        }
        const regex = /^[0-9]+([.,][0-9]+)?$/;
        return regex.test(value);
      } },
      numberOfSeats: { required: requiredIf(function(){
        return this.carType.group != 'TRAILER' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }),numeric },
    },
    car: {
      vin: { required: requiredIf(function (nestedModel) {
        return ! this.car.withoutVin;
      }),
      minLength: minLength(2), maxLength: maxLength(17) },
      year: { required, minLength: minLength(4), maxLength: maxLength(4), numeric },
      kilometers: { required: requiredIf(function(){
        return this.showMileageFields && this.carType.group != 'TRAILER' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }), numeric },
      odometr: { required: requiredIf(function(){
        return this.showMileageFields && this.carType.group != 'TRAILER' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }), numeric },
      birthdayAt: { required: requiredIf(function(){
        return this.carType.group != 'TRAILER' && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id));
      }), minYears: (value) => {
        if (value === null || !value) {
          return  true;
        }
        return (parseInt(moment(value, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) > 17;
      } },
      brand: { required, minLength: minLength(1) },
      model: { required, minLength: minLength(1) },
      number: { required,
        numberValidate(value) {
          if(value && this.orderData.requestData.isEuroCar && value.length >= 3 && value.length <= 20){
            return true;
          }else if(value && value.length >= 5 && value.length <= 8){
            return true;
          }
          return false;
        },
        async numberFormatValidate(value) {
          return await this.validateCarNumber(value, this.autoNumberValidatePatternGroup);
        },
        checkHasMixedLayoutsAutoNumber(value){
          return !this.hasMixedLayouts(value);
        }
      }
    },
    carTypeOption: {
      required: requiredIf(function (nestedModel) {
        return this.carTypeOptions.length !== 0;
      }),
    },
    userData: {
      signerFullName: { required: requiredIf(function (nestedModel) {
        return this.orderData?.requestData?.customerType === 2;
      }) },
      name: { required, minLength: minLength(2) },
      phone: { required, minLength: minLength(19), maxLength: maxLength(19) },
      email: { required, email },
      surname: { required: requiredIf(function (nestedModel) {
        return ! this.isLegalType;
      }), minLength: minLength(2), maxLength: maxLength(30) },
      dateBirth: { required: requiredIf(function (nestedModel) {
        return ! this.isLegalType;
      }), minLength: minLength(10), maxLength: maxLength(10),
      daysInMonth: (value) => {
        if (value === null) {
          return  true;
        }

        return (parseInt(moment(value, 'DD.MM.YYYY').format('DD'))) <= moment(value, 'DD.MM.YYYY').daysInMonth();
      },
      minYears: (value) => {
        if (value === null ) {
          return  true;
        }

        return (parseInt(moment(value, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) > 17;
      },
      minMonth: (value) => {
        //TODO убрать этот метод
        return  true;
      }
      },
      //TODO сделать обязательным для Ванклик
      patronymic: { required: requiredIf(function (nestedModel) {
        return ! this.isLegalType && this.isOneClick();
      }), minLength: minLength(2) },
      identificationCode: { required: requiredIf(function (nestedModel) {
        return ! this.isLegalType && ! this.userData.withoutIdentificationCode;
      }),
      customMinLength(value) {
        if (this.isLegalType || this.userData.withoutIdentificationCode) {
          return true;
        }

        return value !== null && value.length === 10;
      },
      numeric },
      erdpyCode: { required: requiredIf(function () {
        return this.isLegalType;
      }), minLength: minLength(8), maxLength: maxLength(10), numeric },
      address: {
        street: { required, minLength: minLength(2) },
        house: { required },
      },
    }
  },

  mounted() {
    //TODO скорее всего "костальная" форма записи. Посмотреть как это делается с пощью vuejs
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
    if(!this.$listeners.hasOwnProperty('completeCalcAfterChangePlate')){
      this.$root.$on('completeCalcAfterChangePlate', ({ plate, item, status = false, diiaData, diiaFlag, changedCity = false }) => {
        this.completeCalcAfterChangePlate(plate, item, status, diiaData, diiaFlag, changedCity);
      });
    }
    $('body').addClass('transparent-tooltip');
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
  },

  created() {
    this.getCompanyDelails();
    if(parseInt(this.orderData.requestData.registrationType) == 2){
      this.autoNumberValidatePatternGroup = ['temporary'];
    }else{
      this.autoNumberValidatePatternGroup = ['vehicle','trailer','vr','mvs','diplomatic','military'];
    }
    this.fillData();
    this.$store.dispatch('loadPatterns');
  },
  computed: {
    isDescriptionsAgeCustomer(){
      return this.descriptionsAgeCustomer.includes(parseInt(this.orderData.offer.ex_id));
    },
    excludeModules() {
      return this.$store.getters.EXCLUDE_MODULE;
    },
    orderData() {
      return this.$store.state.osagoStore.infoOrder;
    },

    orderDateInfo() {
      return this.$store.state.osagoStore.dateInfo;
    },
    orderRequestData() {
      return this.$store.state.osagoStore.requestData;
    },

    carInfo(){
      return this.$store.state.osagoStore.carInfo;
    },
    carTypeOptions: function () {
      if(this.carType === null || this.carType === undefined) {
        return [];
      }

      if(this.carType.types === undefined && this.carType.engines === undefined) {
        return [];
      }

      if(this.carType.types.length === 0) {
        return this.carType.engines;
      }

      if(this.carType.engines.length === 0) {
        return this.carType.types;
      }
    },
    otherCity: function () {
      let name = 'Інші населені пункти України';

      let results = this.cities.filter((city) => {
        return name.includes(cityRegistration.name_full_name_ua);
      });

      if(results.length === 0) {
        return {
          id: 29751,
          name_full_name_ua: name,
          zone: 5,
        };
      }

      return results[0];
    },
    checkVin: function () {

      if (!this.car.vin || this.car.vin.length == '') {
        return false;
      }

      /*if (this.car.vin.match(/\d{1,}/) === null) {
                return true
            }*/

      if (this.car.vin.match(/[i,o,q]/i) !== null) {
        return true;
      }

      //[A,В,Е,Ё,Й,К,М,Н,О,Р,С,Т,У,Х,Ъ,Ь] - не можно
      //[Б,Г,Д,Э,Ж,З,И,Л,П,Ф,Ц,Ч,Ш,Щ,Ю,Я] - можно
      if (this.car.vin.match(/[Е,Ё,Й,К,М,Н,О,У,Х,Ъ,Ь]/i) !== null) {
        return true;

      }

      return false;
    },

    errorTaxNumber: function () {
      if (this.isLegalType) {
        return  false;
      }

      if(this.userData.identificationCode == '' || this.userData.identificationCode == null) {
        return false;
      }

      if(this.userData.dateBirth == '' || this.userData.dateBirth == null) {
        return false;
      }

      if(this.userData.dateBirth.length == 10 && this.userData.identificationCode.length == 10 && ! this.validateTaxNumber(this.userData.identificationCode, this.userData.dateBirth)) {
        this.errors['personal.identificationCode'] = ['ІПН та Дата народження не співпадають'];

        return true;
      }

      return false;
    },

    errorBirthDate: function () {
      if(this.userData.dateBirth == '' || this.userData.dateBirth == null) {
        return false;
      }

      if((parseInt(moment(this.userData.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
        this.errors['personal.dateBirth'] = ['Страхувальнику повинно бути більше 18 років'];
        return true;
      }else if((parseInt(moment(this.userData.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')-1) * -1) > 100) {
        this.errors['personal.dateBirth'] = ['Страхувальнику повинно бути не більше 100 років'];
        return true;
      }

      return false;
    },
    requiresPrivilegeDocument() {
      return PRIVILEGE_REQUIRED_MODULES.includes(this.orderData?.offer?.moduleName) && parseInt(this.orderData.requestData.customerPrivilege) !== 1;
    }
  },
  watch: {
    'userData.address.street': function (newVal, oldVal) {
      if (newVal) {
        this.userData.address.street = newVal.replace(/["]/g, '');
      }
    },
    'car.birthdayAt': function(newValue) {
      const date = this.car.birthDateOwner;
      if (!date) return false;

      const newDate = moment(newValue, 'DD.MM.YYYY').format( 'YYYY-MM-DD');
      const age1 = this.calculateAge(date);
      const age2 = this.calculateAge(newDate);
      this.checkYearOwner = moment(date, 'YYYY-MM-DD').year() === moment(newValue, 'DD.MM.YYYY').year() || age1 === age2;
    },
    euroChecked: function(newValue) {
      this.changeCarTypes();
    },
    carType: function (newValue,oldVal) {
      this.carTypeOption = this.carTypeOptions[0];
    },
    'userData.surname': async function(newValue, oldValue) {
      if (newValue && newValue.length >= 3) {
        this.isLoadInsuredsListBySurname = true;
        await this.fetchClients(newValue,'surname');
      } else {
        this.insuredsListBySurname = [];
        this.isLoadInsuredsListBySurname = false;
      }
    },
    'userData.name': async function(newValue, oldValue) {
      if (this.isLegalType && newValue && newValue.length >= 3) {
        this.isLoadInsuredsByCompanyName = true;
        await this.fetchClients(newValue,'name');
      } else {
        this.insuredsListBySurname = [];
        this.isLoadInsuredsByCompanyName = false;

      }
    },
    'userData.email': async function(newValue, oldValue) {
      this.userData.email = newValue.toLowerCase();
    },

    'userData.dateBirth': function(newValue, oldValue) {
      delete this.errors['personal.dateBirth'];
      delete this.errors['personal.identificationCode'];

      if(this.isDescriptionsAgeCustomer){
        this.car.birthdayAt = newValue;
      }
    },
    'isDescriptionsAgeCustomer': function(newValue, oldValue) {
      if (newValue && this.userData.dateBirth) {
        this.car.birthdayAt = this.userData.dateBirth;
      }
    },
    'userData.erdpyCode': async function( newValue, oldValue) {
      if(this.isfillData == false && newValue){
        this.isLoadInsuredsByErdpyCode = true;
        await this.fetchClients(newValue,'erdpyCode');
      }
    },
    'userData.identificationCode': async function(newValue, oldValue) {
      if(this.isfillData == false && newValue !== oldValue){
        this.clientId = null;
      }
      if(this.isfillData == false && newValue){
        if(!this.isLegalType){
          this.userData.dateBirth = moment('01.01.1900', 'DD.MM.YYYY')
            .add(newValue.substr(0, 5) - 1, 'day')
            .format('DD.MM.YYYY');
        }

        this.isLoadInsuredsList = true;
        await this.fetchClients(newValue,'identificationCode');
      }
      delete this.errors['personal.identificationCode'];
    },
    'car.brand': function (newVal, oldVal){
      this.model = null;
      this.fetchModels();
    },
    'brandObj': {
      handler: function(newVal, oldVal) {
        this.car.brand = newVal?.name;
        this.modelObj = null;
      },
      deep: true,
    },
    'modelObj': {
      handler: function(newVal, oldVal) {
        this.car.model = newVal?.name;
      },
      deep: true,
    },
    'car.number': function (newVal, oldVal) {
      if (newVal) {
        this.car.number = newVal.replace(/[^a-zA-ZА-ЯҐЄІЇа-яґєіїЁё0-9]/g, '').toUpperCase();
        this.autoFillCarDataByNumber = false;
      }
    },
    'car.vin': function (newVal, oldVal){
      if(newVal){
        this.car.vin = newVal.toUpperCase().replace(/[^a-zA-ZБГДЕЭЖЗИЛПФЦЧШЩЮЯВАЗ0-9]/g, '').replace(/[OoiIqQ]/g, '');
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('completeCalcAfterChangePlate');
  },
  methods: {
    calculateAge: function(birthDate) {
      return moment().diff(birthDate, 'years');
    },
    validateEngineCapacity() {
      const option = this.carTypeOption;
      const errorsKey = 'car_additional_parameters.capacity';
      const capacityValue = parseFloat(this.car_additional_parameters.capacity);

      if (!option || !option.capacity || isNaN(capacityValue) || capacityValue <= 0) {
        this.$set(this.errors, errorsKey, null);
        return;
      }

      const minCapacity = option.capacity.min;
      const maxCapacity = option.capacity.max;

      let isValid = true;
      let errorText = '';

      if (capacityValue < minCapacity) {
        isValid = false;
        errorText = `Объем двигателя (${capacityValue} см³) меньше минимального (${minCapacity} см³).`;
      } else if (capacityValue > maxCapacity) {
        isValid = false;
        errorText = `Объем двигателя (${capacityValue} см³) превышает максимальное (${maxCapacity} см³).`;
      }

      if (!isValid) {
        this.$set(this.errors, errorsKey, [errorText]);
        return false;
      } else {
        this.$set(this.errors, errorsKey, null);
        return true;
      }
    },
    getCompanyDelails() {
      axios.get('/api/company/get-details').then(({ data }) => {
        this.descriptions = data.data
          .filter(item => item.description === 'вік наймолодшого водія')
          .map(item => parseInt(item.companyExternalId));
        this.descriptionsAgeCustomer = data.data
          .filter(item => item.description === 'вік страхув-ника')
          .map(item => parseInt(item.companyExternalId));
      }).catch(err => (console.log(err)));
    },
    async fetchClients(query, type) {
      if (!query) {
        this.isLoadInsuredsList = false;
        return;
      }
      this.insuredsList = [];
      let params = {
        'requestType': 'clientsByUserId',
        'searchText': query,
        'customerType':this.orderData?.requestData?.customerType
      };
      clearTimeout(this.fetchClientsTimeout);
      this.fetchClientsTimeout = setTimeout(async () => {
        let response = await getData(params);
        if(type == 'identificationCode'){
          this.insuredsList = response.data.data.items;
          if(this.fillDataAutoComplit){
            if(this.insuredsList.length > 0) {
              this.selectInsuredInfo(this.insuredsList[0]);
            }
            this.fillDataAutoComplit = false;
          }
        }else if (type == 'erdpyCode'){
          this.insuredsListByErdpyCode = response.data.data.items;
        }else if (type == 'surname'){
          this.insuredsListBySurname = response.data.data.items;
        }else if (type == 'name'){
          this.insuredsListByCompanyName = response.data.data.items;
        }
        this.isLoadInsuredsList = false;
        this.isLoadInsuredsByErdpyCode = false;
        this.isLoadInsuredsByCompanyName = false;
        this.isLoadInsuredsListBySurname = false;
        // this.$store.commit('SET_CLIENT', null);
        // this.clientId = null
      }, 1000);
    },
    getClientDataForUpdating(){
      if(!this.isfillData){
        let orderData = this.getOrderData();
        let orderDraft =  orderData.orderDraft;
        this.updateClientData(orderDraft);
      }
    },
    checkInvalidCartype() {
      const orderData = this.getStoredOrderData();
      return !(orderData?.requestData?.customerType === 3 && this.carTypeOption.value === 'B4');
    },
    getStoredOrderData() {
      return this.$store.state.osagoStore.infoOrder;
    },
    onAlertClose() {
      //действие после закрытия алерта
      $('#custom-alert-orderSteps').modal('hide');
    },
    otherCountry: function () {
      let name = 'ТС зареєстровано в іншій країні';

      let results = this.otherVariants.filter((city) => {
        return name.includes(city.name_full_name_ua);
      });

      if(results.length === 0) {
        return {
          id: 0,
          name: name,
          name_full_name_ua: name,
          zone: 0,
        };
      }
      return results[0];
    },
    euroStatus(){
      if(this.euroChecked === true){
        this.cityRegistration = this.otherCountry();
      }else{
        this.cityRegistration = {
          id: null,
          name: null,
          name_full_name_ua: null,
          zone: null,
        };
      }
    },
    changeCarTypes() {
      let carTypes = [
        {
          'name':'Легкові автомобілі',
          'group':'CAR',
          'external_id':'B1',
          'types':[
            { 'name':'до 1600 см3','value':'B1' },
            { 'name':'1601-2000 см3','value':'B2' },
            { 'name':'2001-3000 см3','value':'B3' },
            { 'name':'более 3001 см3','value':'B4' }
          ],
          'engines':[]
        },
        {
          'name':'Автобус',
          'group':'BUS',
          'engines':[],
          'external_id':'D1',
          'types':[
            { 'name':'менше 20 осіб','value':'D1' },
            { 'name':'більше 20 осіб','value':'D2' }
          ]
        },
        {
          'name':'Вантажні автомобілі',
          'group':'CARGO',
          'engines':[],
          'types':[
            { 'name':'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)','value':'C0' },
            { 'name':'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))','value':'C1' },
            { 'name':'С2 (з вантажопідйомністю більше 2т)','value':'C2' }
          ]
        },
        {
          'name':'Причіп, Трейлер',
          'group':'TRAILER',
          'engine':null,
          'engines':[],
          'external_id':'E',
          'types':[
            { 'name':'До вантажного авто','value':'E' },
            { 'name':'До легкового авто','value':'F' }
          ]
        },
        {
          'name':'Мотоцикли та моторолери',
          'group':'BIKE',
          'external_id':'A1',
          'types':[
            { 'name':'300 см3 або менше','value':'A1' },
            { 'name':'більше 300 см3','value':'A2' }
          ],
          'engines':[]
        },
        {
          'name':'Легковий електромобіль',
          'group':'CAR',
          'external_id':'B5',
          'engine':null,
          'engines':[],
          'types':[
            { 'name':'','value':'B5' }
          ]
        }
      ];

      if(this.orderData?.requestData?.customerType === 3){
        let availableEngines = ['A1', 'A2', 'B1', 'B2', 'B3'];
        if(this.euroChecked){
          availableEngines = ['A2', 'B1', 'B2', 'B3'];
          if(this.carType.group == 'BIKE') this.carType = carTypes[0];
        }
        carTypes = carTypes.filter((carType)=>{
          return availableEngines.includes(carType.external_id);
        });
      }

      this.carTypes = carTypes;
    },
    fillData(){
      this.isfillData = true;

      if(this.orderRequestData.cityInfo && this.orderRequestData.cityInfo.id == 0){
        this.euroChecked = true;
      }

      if(this.orderData?.requestData?.customerType === 3){
        this.euroChecked = false;
        this.euroDisabled = true;
      }

      if(this.$store.state.carsStore.marks === null || this.$store.state.carsStore.marks === undefined){
        return false;
      }else{
        this.carBrands = this.$store.state.carsStore.marks;
      }

      this.privilegeList = this.$store.getters.CUSTOMER_PRIVILEGE;

      let foundBrand = null;
      let foundModel = null;

      if (this.$store.state.osagoStore.carInfo) {
        this.car = JSON.parse(JSON.stringify(this.$store.state.osagoStore.carInfo));
      }

      if (this.$store.getters.GET_CLIENT) {
        this.clientId = this.$store.getters.GET_CLIENT;
      }

      let data = this.$store.state.osagoStore.fullInfoOrder;
      // заполнение данными поля, которые мы ввели ранее. Данная логика работает, если
      // c финального шага офомления вернулись сюда.
      if(!this.euroChecked){
        if (this.orderData?.requestData?.cityInfo && this.orderData?.requestData?.cityInfo?.id) {
          this.cityRegistration = JSON.parse(JSON.stringify(this.orderData.requestData.cityInfo));
        } else {
          this.cityRegistration = null;
        }
      }else{
        this.cityRegistration = this.otherCountry ();
      }

      if (data) {
        if (data.car) {
          //TODO этот момент нужно будет пофиксить к норму виду.
          this.car.brand = data.car.brand;
          this.car.number = data.car.number;
          this.car.year = data.car.year;
          this.car.age = data.car.age;
          this.car.birthDateOwner = data.car.birthDateOwner;
          this.car.vin = data.car.vin;
          this.car.model = data.car.model;
          if(data.car?.kilometers){
            this.car.kilometers = data.car?.kilometers;
          }
          if(data.car?.odometr){
            this.car.odometr = data.car?.odometr;
          }
          this.car.birthdayAt = data.car.birthdayAt || this.orderData.requestData.car.birthdayAt;
        }
        else{
          this.car.brand = '';
          this.brandObj = null;
          this.modelObj = null;
          this.car.number = '';
          this.car.year = '';
          this.car.age = '';
          this.car.birthDateOwner = '';
          this.car.vin = '';
          this.car.withoutVin = false;
          this.car.model = '';
          this.car.birthdayAt = '';
        }
        //TODO сделать рефакторинг для car_additional_parameters
        if (data.car.additional_parameters) {
          this.car_additional_parameters.capacity = data.car.additional_parameters.capacity;
          this.car_additional_parameters.kvt = data.car.additional_parameters.kvt;
          this.car_additional_parameters.numberOfSeats = data.car.additional_parameters.numberOfSeats;
          this.car_additional_parameters.ownWeight = data.car.additional_parameters.ownWeight;
          this.car_additional_parameters.totalWeight = data.car.additional_parameters.totalWeight;
        } else if (this.car.additionalParameters) {
          this.car_additional_parameters.capacity = this.car.additionalParameters.capacity;
          this.car_additional_parameters.kvt = this.car.additionalParameters.kvt;
          this.car_additional_parameters.numberOfSeats = this.car.additionalParameters.numberOfSeats;
          this.car_additional_parameters.ownWeight = this.car.additionalParameters.ownWeight;
          this.car_additional_parameters.totalWeight = this.car.additionalParameters.totalWeight;
        } else {
          this.car_additional_parameters.capacity = null;
          this.car_additional_parameters.kvt = null;
          this.car_additional_parameters.numberOfSeats = null;
          this.car_additional_parameters.ownWeight = null;
          this.car_additional_parameters.totalWeight = null;
        }

        if(data.cityRegistration) {
          this.cityRegistration = data.cityRegistration;
        }
        if(data.customer.address.cityObject?.id){
          this.cityСlient = data.customer.address.cityObject;
        }
        this.carOwner = data.isCarOwner;
        this.isFop = data.isFop;
        this.setAutoCategoryType(data.autoCategoryType);

        if (this.orderData?.offer?.cityRegistration) {
          this.cityRegistration = JSON.parse(JSON.stringify(this.orderData?.offer?.cityRegistration));
        }

        if (data.customer) {
          let userDataInfo = Object.entries(data.customer).map(([key, value]) => ({ key,value }));
          userDataInfo.forEach((element) => {
            let data = this.processObject(element.value);
            data = (element.key == 'dateBirth') ? moment.unix(data).format('DD.MM.YYYY') : data;
            this.userData[element.key] = data;
          });

          this.userData.documentation.type = this.convertDocumentToNumber(this.userData.documentation.type) ?? this.userData.documentType;
        }
        if (data.orderId) {
          this.orderId = data.orderId;
        }

        if(this.isFromHistory() && data.parentOrderId){
          this.parentOrderId = data.parentOrderId;
          this.prolongOrderId = data.prolongOrderId;
        }

      }else{
        if(this.orderData?.requestData?.autoCategoryType) {
          this.setAutoCategoryType(this.orderData?.requestData?.autoCategoryType);
        }
        if(!this.car.brand){
          this.brandObj = null;
        }
        if(!this.car.model){
          this.modelObj = null;
        }
      }

      // //TODO изменить этот момент на работу с хранилищем
      if (this.orderData?.requestData?.customerType == 2) {
        this.isLegalType = true;
        this.userData.dateBirth = null;
      }

      if((!this.car.brand || this.car.brand === null || this.car.brand.length === 0) || (!this.car.model || this.car.model === null || this.car.model.length === 0)){
        this.identifyModel();
      }else if (this.car.brand && this.car.brand.length > 0 && this.car.model && this.car.model.length > 0){
        foundBrand = this.carBrands.find((e) => {
          return e.name.toLowerCase() == this.car.brand.toLowerCase();
        });
        if(!foundBrand){
          this.addNewCar(this.car.brand, 'brand');
        }else{
          this.brandObj = foundBrand;
        }
        let tmp_car = JSON.parse(JSON.stringify(this.car));
        setTimeout(() => {
          foundModel = this.carModels.find((e) => {
            return e.name.toLowerCase() == tmp_car?.model?.toLowerCase();
          });
          if(!foundModel){
            this.addNewCar(tmp_car.model, 'model');
          }else{
            this.modelObj = foundModel;
          }
        }, 300);
      }

      this.isfillData = false;

      if(!!this.orderData?.requestData?.identificationCode && !this.userData.identificationCode && this.userData.identificationCode != this.orderData?.requestData?.identificationCode){
        this.userData.identificationCode = this.orderData?.requestData?.identificationCode;
        this.fetchClients(this.userData.identificationCode,'identificationCode');
        this.fillDataAutoComplit = true;
      }
    } ,
    processObject(obj) {
      if (typeof obj === 'object' && obj !== null) {
        // Рекурсивно обрабатываем вложенные объекты
        for (const prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            obj[prop] = this.processObject(obj[prop]);
          }
        }
        return obj;
      } else if (typeof obj === 'string') {
        // Если это строка, применяем trim()
        return obj.trim();
      } else {
        // Остальные типы оставляем без изменений
        return obj;
      }
    },
    btnIdentifyModel(){
      this.orderRequestData.changedCarTypeFlag = this.orderRequestData.changedCarTypeOptionFlag = this.orderRequestData.changedCityFlag = false;
      this.loadingSearchCarData = true;
      this.identifyModel();
    },
    isInvalid(val) {
      return val == null && this.submitCheck;
    },
    completeCalcAfterChangePlate(plate, item, status, diiaData, diiaFlag, changedCity){
      this.getClientDataForUpdating();
      return new Promise((resolve) => {
        this.showAnimateModal();
        if(!status) {
          this.car.number = plate;
          this.compinatePlate = JSON.stringify([this.car.number]);
          this.$root.$emit('data-change-reactive-total-price', {
            item: item,
          });
          this.hideAnimateModal();
          this.submitNextStep();
        }else{
          if(!diiaData){
            this.$store.commit('SET_CAR_INFO', this.orderRequestData.car);

            this.car = JSON.parse(JSON.stringify(this.orderRequestData.car));
            this.$store.commit('SET_CAR_INFO', this.car);
            setTimeout(() => {
            }, 500);

            this.orderData.requestData = JSON.parse(JSON.stringify(this.orderRequestData));
            this.cityRegistration = JSON.parse(JSON.stringify(this.orderRequestData.cityInfo));
            this.fillData();
            this.compinatePlate = JSON.stringify([this.car.number]);


            if(this.car.mark){
              let foundBrand = this.carBrands.find((e) => {
                return e.name.toLowerCase() == this.car.mark.toLowerCase();
              });
              if(!foundBrand){
                this.addNewCar(this.car.mark, 'brand');
              }else{
                this.brandObj = foundBrand;
              }

              if(this.car.model){
                setTimeout(() => {
                  let foundModel = this.carModels.find((e) => {
                    return e.name.toLowerCase() == this.car.model.toLowerCase();
                  });
                  if(!foundModel){
                    this.addNewCar(this.car.model, 'model');
                  }else{
                    this.modelObj = foundModel;
                  }
                }, 300);
              }
            }
            setTimeout(() => {
              this.submitNextStep();
              resolve();
            }, 500);
          }else{
            setTimeout(() => {
              this.submitNextStep();
              resolve();
            }, 500);
          }
        }
      });
    },
    showAnimateModal() {
      this.$root.$emit('showAnimateModalPreloader', {
        dataTitle : 'Триває процес аналізу даних авто',
        dataSubTitle: 'Це займає від 2 до 10 секунд'
      });
    },
    hideAnimateModal() {
      this.$root.$emit('hideAnimateModalPreloader');
    },
    showCompinatePlatePopup(stepCityData = null){
      let diiaFlag = false;
      let cartype;

      if(this.carType.external_id == 'B5'){
        cartype = this.carType.external_id;
      }else{
        this.carType.external_id = this.carTypeOption.value;
        cartype = this.carTypeOption.value;
      }

      this.car.additional_parameters = this.car_additional_parameters;

      let params = { 'calc_car_plate':[this.orderData.requestData.car.number],'calc_car_type':this.orderData.requestData.autoCategoryType,'step_car':this.car.number,'dataTranslate': {
        'titileLicensePlate': ('Параметри авто відрізняють від тих, які були вказані під час калькуляції. Щоб продовжити оновіть ціну або залиште дані авто, які співпадають з розрахунковими'),
        'titleCarType':('Тип транспортного засобу відрізняється від тиго, який був вказан під час калькуляції. Щоб продовжити оновіть ціну або залиште дані авто, які співпадають з розрахунковими'),
        'calcData':('Дані авто при калькуляції'),
        'stepData':('Дані авто, які ми отримали'),
        'licensePlate':('Номерний знак'),
        'carType':('Тип ТЗ'),
        'carCapacity':('Об’єм двигуна'),
        'ragistrationPlace':('Місце реєстрації'),
        'year':('Рік випуску'),
        'birthdayAt':('Дата народження водія'),
        'brand':('Марка авто'),
        'vin':('VIN-код'),
        'updatePrice':('Оновити ціну'),
        'leave':('Залишити'),
        'IdentificationCode':('ІПН'),
        'attention':('Увага'),
      },'calcDataCity':this.orderRequestData.cityInfo,'calcCarInfo':this.orderRequestData.car,'tariffType':this.productType, 'stepCityData':stepCityData, 'changedCity': this.changedCity, 'curCarType': cartype, 'curCarInfo': this.car, 'descriptionsAgeCustomer':this.isDescriptionsAgeCustomer,
      'calcIdentificationCode':this.orderData?.requestData?.identificationCode, 'curIdentificationCode':this.userData.identificationCode, 'calcProgrammName': this.orderData?.offer?.programmName };
      this.showAnimateModal();
      this.mixinCheckVehicle(params,diiaFlag);
    },
    addNewCar(newEl, type) {
      if (typeof newEl === 'string') {
        // Если newEl является строкой, создаем новый объект
        const newCar = { id: Date.now(), name: newEl };
        if (type === 'model') {
          this.carModels.push(newCar);
          this.modelObj = newCar;
        } else if (type === 'brand') {
          this.carBrands.push(newCar);
          this.brandObj = newCar;
        }
      }else{
        if (type === 'model') {
          this.modelObj = newEl;
        } else if (type === 'brand') {
          this.brandObj = newEl;
        }
      }
    },
    checkIsEwa() {
      return this.isEwa(this.orderData?.offer?.moduleId);
    },
    isFromHistory() {
      return this.$route.query.from === 'history';
    },
    updateClientData(orderDraft){
      if(this.isfillData) return;
      if (
        (this.userData.identificationCode && this.userData.identificationCode.length === 10) || (this.userData.erdpyCode && this.userData.erdpyCode.length === 8) ||
              (this.userData.phone !== null && this.userData.phone !== '+38 (0' && this.userData.phone.length === 19) ||
              (this.userData.email !== null && this.userData.email !== '' && !this.$v.userData.email.$invalid)
      ) {
        orderDraft = (orderDraft instanceof Event || !orderDraft) ? this.getOrderData()?.orderDraft : orderDraft;
        if (orderDraft) {
          saveClient(orderDraft).then(response => {
            if (response?.data?.status == 'success') {
              this.clientId  = response?.data?.data?.id;
              this.$store.commit('SET_CLIENT', this.clientId);
              let fullInfoOrder = this.$store.state.osagoStore.fullInfoOrder;
              if(orderDraft.customer?.documentation?.dateOfIssue){
                orderDraft.customer.documentation.dateOfIssue = this.showOtkDate(orderDraft.customer.documentation.dateOfIssue);
              }
              fullInfoOrder.customer = orderDraft.customer;
              fullInfoOrder.car = orderDraft.car;
              this.$store.commit('SET_FULL_INFO_ORDER', fullInfoOrder);
            }
          });
        }
      }
    },
    selectInsuredInfo(insured) {
      this.isfillData = true;
      this.selectedPibInn = insured;
      this.clientId = insured.id;

      let selectDocument = false;
      let selectVehicle = false;
      if(insured.documents.length === 1){
        selectDocument = insured.documents[0];
      }

      if(insured.vehicles.length === 1 && !this.isCarSelected()) {
        selectVehicle = insured.vehicles[0];
      }
      let params = {
        'selectPibInn' : insured,
        'selectVehicle' : selectVehicle,
        'selectTourists' : false,//insured.selectTourists,
      };
      this.$store.commit('SET_CLIENT', insured.id);
      this.saveFillData(params);
      if(!this.isLegalType){
        params['selectDocument'] = selectDocument;
      }
      if((!selectVehicle && insured.vehicles.length > 1) || (!this.isLegalType && !selectDocument && insured.documents.length > 1)){
        this.fillClientData();
        return;
      }

    },
    getNameMask() {
      //TODO не ясно как в этом плане выставлять количество разрешенных знаков
      // И конечно же вынести подобный переменные в константы
      if (this.userData.documentation.type === 'DOCUMENT_FOREIGN_PASSPORT' ||
                this.userData.documentation.type === 'DOCUMENT_EXTERNAL_PASSPORT' ||
                this.userData.documentation.type === 'DOCUMENT_RESIDENCE_PERMIT'
      ) {
        return 'GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG';
      }

      return 'YYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYY';
    },
    backToOsagoResult() {
      let params = this.orderData.requestData;
      params.franchise = 'all';

      let queryParams = {
        ...params,
        experience: encodeURIComponent(JSON.stringify(params.experience)), // Кодируем в JSON
        carTypeInfo: encodeURIComponent(JSON.stringify(params.carTypeInfo)), // Кодируем в JSON
        cityInfo: encodeURIComponent(JSON.stringify(params.cityInfo)),       // Кодируем в JSON
        car: encodeURIComponent(JSON.stringify(params.car))                 // Кодируем в JSON
      };

      this.$router.push({ name: 'osagoResults', query: queryParams });
    },
    isOneClick() {
      return this.orderData?.offer?.moduleId == 2;
    },
    disableCarVinBlock() {
      //TODO временный решение, для возможности скрывать некоторые данные для евы
      return this.isEwa(this.orderData?.offer?.moduleId) &&
                (this.orderData.requestData.autoCategoryType == 'F' || this.orderData.requestData.autoCategoryType == 'E');
    },
    disableIdentificationCodeBlock() {
      return this.orderData.offer.company.inn_status;
    },
    disableIdentificationCode() {
      this.userData.documentation.type = 'DOCUMENT_PASSPORT';
      this.userData.identificationCode = null;
      this.userData.withoutIdentificationCode = ! this.userData.withoutIdentificationCode;
    },
    disableCarVin() {
      this.hideCarVin = ! this.hideCarVin;
    },
    getNumberMask() {
      return 'MMMMMMMMM';
    },
    setAutoCategoryType(autoCategory){
      if(autoCategory == 'B1' || autoCategory == 'B2' || autoCategory == 'B3' || autoCategory == 'B4'){
        this.carType = this.carTypes[0];
      }else if(autoCategory == 'D1' || autoCategory == 'D2'){
        this.carType = this.carTypes[1];
      }else if(autoCategory == 'C0' || autoCategory == 'C1' || autoCategory == 'C2'){
        this.carType = this.carTypes[2];
      }else if(autoCategory == 'E' || autoCategory == 'F'){
        this.carType = this.carTypes[3];
      }else if(autoCategory == 'A1' || autoCategory == 'A2'){
        this.carType = this.carTypes[4];
      }else if(autoCategory == 'B5'){
        this.carType = this.carTypes[5];
      }
      setTimeout(() => {
        this.carTypeOption = this.carTypeOptions.find((item, index, list) => {
          return autoCategory == item.value;
        });
        setTimeout(() => { this.disableCheckCarData = false; },500);
      }, 500);
    },
    showPrice(offer){
      return Number(offer.price) ;
    },
    showDiscountPrice(offer){
      return (offer.prolongOrderId) ? offer.price: Number(offer.dynamicDiscountPrice || offer.discountPrice || (offer.price - (offer.dynamicDiscountedSum || 0)));
    },
    showOtkDate(otkDate) {
      return moment.unix(otkDate).format('DD.MM.YYYY');
    },
    showRegistrationType(){
      return this.$_.findWhere(this.registrationTypes, { id: parseInt(this.orderData.requestData.registrationType) }).value;
    },
    showRegistrationCity() {
      let cityRegistrationPlaceholder;

      if(this.orderRequestData?.cityInfo && typeof this.orderRequestData?.cityInfo === 'object') {
        cityRegistrationPlaceholder = this.orderRequestData?.cityInfo?.name_full_name_ua;
      }
      return cityRegistrationPlaceholder;
    },
    isArx(){
      return [1027].includes(parseInt(this.orderData?.offer?.ex_id));
    },
    isUniqa(){
      return [1030].includes(parseInt(this.orderData?.offer?.ex_id));
    },
    isModulesForDisableFields(){
      return this.isArx() || this.isUniqa();
    },
    isVuso(){
      return [1001].includes(parseInt(this.orderData?.offer?.ex_id));
    },
    identifyModel(checkCombine = true) {
      if (this.car.number && this.car.number.length) {
        axios({ url: '/api/directories/car/' + this.car.number.trim(), method: 'GET' }).then(({ data }) => {
          let result = data.data;
          let foundBrand = null;
          let foundModel = null;
          if (result) {
            this.car.brand = null;
            this.car.brand = result.mark;
            foundBrand = this.carBrands.find((e) => {
              return e.name.toLowerCase() == result.mark.toLowerCase();
            });
            if(!foundBrand){
              this.addNewCar(result.mark, 'brand');
            }else{
              this.brandObj = foundBrand;
            }

            if(!this.orderRequestData.changedCityFlag) {
              if(result.city){
                this.euroChecked = false;
                this.cityRegistration = { id: null,name: null,name_full_name_ua: null,zone: null };
                this.cityRegistration.id = result.city.id;
                this.cityRegistration.name = result.city.name_ua;
                this.cityRegistration.name_full_name_ua = result.city.name_full_name_ua;
                this.cityRegistration.zone = result.city.zone;
              }else{
                if(this.orderRequestData.cityInfo && this.orderRequestData.cityInfo.id == 0){
                  this.cityRegistration = this.otherCountry();
                }else{
                  if (this.orderData?.requestData?.cityInfo && this.orderData?.requestData?.cityInfo?.id) {
                    this.cityRegistration = JSON.parse(JSON.stringify(this.orderData?.requestData?.cityInfo));
                  } else {
                    this.cityRegistration.id = null;
                    this.cityRegistration.name = null;
                    this.cityRegistration.name_full_name_ua = null;
                    this.cityRegistration.zone = null;
                  }
                }
              }
            }
            else{
              if (this.orderData?.requestData?.cityInfo && this.orderData?.requestData?.cityInfo?.id) {
                this.cityRegistration = JSON.parse(JSON.stringify(this.orderData?.requestData?.cityInfo));
              } else {
                this.cityRegistration.id = null;
                this.cityRegistration.name = null;
                this.cityRegistration.name_full_name_ua = null;
                this.cityRegistration.zone = null;
              }
            }
            //Княжа, Uniqa
            if([1007,1030].includes(parseInt(this.orderData.offer.ex_id)) && result.autoCategory){
              this.autoFillCarDataByNumber = true;
            }else{
              this.autoFillCarDataByNumber = false;
            }

            if(!this.orderRequestData.changedCityFlag && result.autoCategory) {
              this.setAutoCategoryType(result.autoCategory);
            }else{
              this.setAutoCategoryType(this.orderRequestData.autoCategoryType);
            }

            if(result.additionalParameters){
              this.car_additional_parameters.capacity = result.additionalParameters.capacity;
              this.car_additional_parameters.kvt = result.additionalParameters.kvt;
              this.car_additional_parameters.numberOfSeats = result.additionalParameters.numberOfSeats;
              this.car_additional_parameters.ownWeight = result.additionalParameters.ownWeight;
              this.car_additional_parameters.totalWeight = result.additionalParameters.totalWeight;
            }else{
              this.car_additional_parameters.capacity = null;
              this.car_additional_parameters.kvt = null;
              this.car_additional_parameters.numberOfSeats = null;
              this.car_additional_parameters.ownWeight = null;
              this.car_additional_parameters.totalWeight = null;
            }

            this.changedCity = false;



            setTimeout(() => {
              this.car.model = result.model;
              foundModel = this.carModels.find((e) => {
                return e.name.toLowerCase() == result.model.toLowerCase();
              });
              if(!foundModel){
                this.addNewCar(result.model, 'model');
              }else{
                this.modelObj = foundModel;
              }
            }, 300);
            this.car.year = result.year;
            this.car.vin = result.vin;
            this.car.age = result.age;
            this.car.birthDateOwner = result.birthDateOwner;
          }
          else {
            //TODO сделать через цикл
            this.car.brand = null;
            this.car.birthDateOwner = null;
            this.brandObj = null;
            this.car.model = null;
            this.modelObj = null;
            this.car.year = null;
            this.car.vin = null;
          }
          this.loadingSearchCarData = false;
        }).catch(err => (console.log(err)));
      }else{
        this.loadingSearchCarData = false;
      }
    },
    searchCities(query) {
      this.cityRegistration = query;
      this.getClientDataForUpdating();
      this.changedCity = true;
      if(query.length > 1){
        this.fetchCities(query,1);
      }
    },
    selectClientCities(query){
      this.cityСlient = query;
      this.getClientDataForUpdating();
    },
    searchClientCities(query) {
      if(query.length > 1){
        this.fetchCities(query,2);
      }
    },
    fetchCities(query, caseCityType) {
      axios.get('/api/directories/cities/find?city=' + query).then(({ data }) => {
        this.cities = data.data;
        if(caseCityType == 1){
          this.citiesOptions = data.data;
          if (this.citiesOptions.length === 0) {
            this.citiesOptions.push(this.otherCity);
          }
        }else if(caseCityType == 2){
          this.citiesСlientOptions = data.data;
          if (this.citiesСlientOptions.length === 0) {
            this.citiesСlientOptions.push(this.otherCity);
          }
        }

      }).catch(err => (console.log(err)));
    },
    fetchModels_old() {
      if (this.car.brand) {
        let brandId = this.$store.state.carsStore.marks.find(mark => mark.name.toLowerCase() === this.car.brand.toLowerCase())?.id;
        let models = this.$store.state.carsStore.models;
        const currentModels = models.filter(function (e) {
          return e.car_mark_id == brandId;
        });
        this.carModels = currentModels;
        this.car.model = currentModels[0]?.name;
      }
    },
    async fetchModels() {

      if (this.car.brand) {

        let response = await getMark(this.car.brand);
        let currentModels = [];

        if(response && response?.data?.data?.model ){
          currentModels = response?.data?.data?.model.map(item => ({
            car_mark_id: item.car_mark_id,
            id: item.id,
            name: item.name,
          }));
        }

        this.carModels = currentModels;
        if(!this.car.model){
          this.car.model = currentModels[0]?.name;
        }
      }
    },
    scrollToErrors() {
      try {
        setTimeout(() => {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.error').offset().top - 200
          }, 500);
        }, 300);
      }catch (e) {
        console.error(e);
      }
    },
    getOrderData() {
      if (this.errorTaxNumber || this.checkVin) {
        this.scrollToErrors();

        return false;
      }

      let userData = JSON.parse(JSON.stringify(this.userData));

      if(! this.isLegalType && userData.documentation.dateOfIssueError){
        return false;
      }
      if( this.isLegalType ){
        userData.dateBirth = null;
      }else{
        userData.dateBirth = moment(
          userData.dateBirth,
          'DD.MM.YYYY'
        ).utc(true).unix();
      }
      userData.address.cityId = this.cityСlient?.id || '';
      userData.address.cityObject = this.cityСlient;
      if (userData.erdpyCode) {
        userData.identificationCode = userData.erdpyCode;
      }
      userData.customerType = this.orderData?.requestData?.customerType;
      userData.phone = (userData.phone == '+38 (0') ? '' : userData.phone;

      let data = {
        productType: this.productType,
        dateFromMax: this.orderData.offer.dateFromMax,
        franchise: Number(this.orderData.offer.franchise),
        moduleId: this.checkIsEwa(),
        companyId: this.orderData.offer.companyId,
        prolongOrderId: this.orderData?.prolongOrderId,
        //TODO писать переменные в одном стиле camelCase
        isTaxi: this.orderData.requestData.isTaxi,
        autoCategoryType : this.orderData.requestData.autoCategoryType,
        registrationPlaceId: this.cityRegistration?.id || 0,//this.orderData.requestData.registrationPlaceId,
        customerPrivilege: this.orderData.requestData.customerPrivilege,
        isEuroCar: this.orderData.requestData.isEuroCar,
        isCarOwner: this.carOwner,
        isFop: this.isFop,
        otkDate: this.orderData.requestData.otkDate || null,
        endDate: this.orderData.requestData.endDate || null,
        startDate: this.orderDateInfo.startDate ? moment(this.orderDateInfo.startDate,'DD.MM.YYYY').startOf('day').utc(true).unix() : null,
        finishAt: this.orderDateInfo.endDate ? moment(this.orderDateInfo.endDate,'DD.MM.YYYY').startOf('day').utc(true).unix() : null,
        period_id: this.orderDateInfo.period_id || 12,
        cityRegistration: this.cityRegistration,
        car: {
          vin: this.car.vin,
          year: this.car.year,
          age: this.car.age,
          birthDateOwner: this.car.birthDateOwner,
          brand: this.car.brand,
          model: this.car.model,
          number: this.car.number,
          withoutVin: this.car.withoutVin,
          kilometers: this.car.kilometers,
          odometr: this.car.odometr,
          birthdayAt: this.car.birthdayAt,
          additional_parameters:{
            capacity: this.car_additional_parameters.capacity,
            ownWeight: this.car_additional_parameters.ownWeight,
            totalWeight: this.car_additional_parameters.totalWeight,
            kvt: this.car_additional_parameters.kvt,
            numberOfSeats: this.car_additional_parameters.numberOfSeats,
          },
        },
        customer: userData,
        price: this.orderData.offer.price,
        discountPrice: this.orderData.offer?.discountPrice,
        discountPercent: this.orderData.offer?.discountPercent,
        dynamicDiscountPrice: this.orderData.offer?.dynamicDiscountPrice,
        dynamicDiscountPercent: this.orderData.offer?.dynamicDiscountPercent,
        dynamicDiscountedSum: this.orderData.offer?.dynamicDiscountedSum,
        dynamicEarnings: this.orderData.offer?.dynamicEarnings,
        earnings: this.orderData.offer?.earnings,
        offerId: this.orderData.offer.offerId,
        dgo: {
          id: this.orderData.offer.dgoId,
          compensation: this.orderData.offer.dgoCoverage,
          company_id: this.orderData.offer.dgoCompanyId,
          price: this.orderData.offer.dgoPrice,
        },
        dgoId: this.orderData.offer.dgoId,
        dgoCoverage: this.orderData.offer.dgoCoverage,
        dgoCompanyId: this.orderData.offer.dgoCompanyId,
        dgoPrice: this.orderData.offer.dgoPrice,
        autolawyer: {
          id: this.orderData.offer.autolawyerId,
          program: this.orderData.offer.autolawyerProgram,
          price: this.orderData.offer.autolawyerPrice,
          zone: this.orderData.requestData.zone,
          auto_category_type: this.orderData.offer.autoCategoryType,
        },
        autolawyerId: this.orderData.offer.autolawyerId,
        autolawyerPrice: this.orderData.offer.autolawyerPrice,
        autolawyerZone: this.orderData.requestData.zone,
        autolawyerAutoCategoryType: this.orderData.offer.autoCategoryType,
        autolawyerProgram: this.orderData.offer.autolawyerProgram,
        statusId: 1, // TODO добавить в словари фронта
        clientId: this.clientId,
        allowedDocuments: this.orderData.offer.available_documents ?? this.orderData.offer.allowed_documents ?? null,
        link_id: this.orderData.offer.link_id ?? this.orderData.link_id ?? null,
      };

      if(this.orderData.offer?.dynamicDiscountedSum > 0){
        data.discountDetails = { dynamicDiscountPrice:this.orderData.offer?.dynamicDiscountPrice,
          dynamicDiscountPercent:this.orderData.offer?.dynamicDiscountPercent,
          dynamicDiscountedSum:this.orderData.offer?.dynamicDiscountedSum,
          dynamicEarnings:this.orderData.offer?.dynamicEarnings,
          earnings:this.orderData.offer?.earnings };
      }else{
        data.discountDetails = null;
      }

      let orderDraft = JSON.parse(
        JSON.stringify(
          data
        )
      );
      if (this.orderId) {
        orderDraft.orderId = this.orderId;
      }

      if(this.isFromHistory() && this.parentOrderId){
        orderDraft.parentOrderId = this.parentOrderId;
      }

      if(this.typeDocumentId) {
        const customerType = this.orderData?.requestData?.customerType;
        if (!customerType || customerType !== 2) {
          orderDraft.customer.documentation.type = this.typeDocumentId;
        }
      }

      if (orderDraft.dgoPrice && ! isNaN(parseFloat(orderDraft.dgoPrice))) {
        if (this.orderData.offer?.discountPrice) {
          orderDraft.discountPrice = parseFloat(orderDraft.discountPrice) - parseFloat(orderDraft.dgoPrice);
          orderDraft.discountPrice = orderDraft.discountPrice.toFixed(2);
          data.discountPrice = orderDraft.discountPrice;
        } else {
          orderDraft.price = parseFloat(orderDraft.price) - parseFloat(orderDraft.dgoPrice);
          orderDraft.price = orderDraft.price.toFixed(2);
          data.price = orderDraft.price;
        }
      }

      if (orderDraft.autolawyerPrice && ! isNaN(parseFloat(orderDraft.autolawyerPrice))) {
        if (this.orderData.offer?.discountPrice) {
          orderDraft.discountPrice = parseFloat(orderDraft.discountPrice) - parseFloat(orderDraft.autolawyerPrice);
          orderDraft.discountPrice = orderDraft.discountPrice.toFixed(2);
          data.discountPrice = orderDraft.discountPrice;
        } else {
          orderDraft.price = parseFloat(orderDraft.price) - parseFloat(orderDraft.autolawyerPrice);
          orderDraft.price = orderDraft.price.toFixed(2);
          data.price = orderDraft.price;
        }
      }

      if( this.isLegalType ){
        orderDraft.customer.dateBirth = null;
      }
      orderDraft.customer.documentation.dateOfIssue = moment(
        orderDraft.customer.documentation.dateOfIssue,
        'DD.MM.YYYY'
      ).unix();

      orderDraft.customer.documentation.endDateOfIssue = orderDraft.customer.documentation.endDateOfIssue ?
        moment(orderDraft.customer.documentation.endDateOfIssue, 'DD.MM.YYYY').unix()
        : null;

      return { data: data, orderDraft:orderDraft };
    },
    saveDraft() {
      let orderData = this.getOrderData();
      let orderDraft = orderData?.orderDraft;
      let data = orderData?.data;

      this.updateClientData(orderDraft);

      if (orderDraft) {
        saveOrder(orderDraft).then(response => {
          if (response?.data?.data[0]?.statusId === 1) {
            data.orderId = response?.data?.data[0]?.id;
            this.orderId  = response?.data?.data[0]?.id;
            data.customer.documentation.type = orderDraft.customer.documentation.type;

            delete data.statusId;
            this.$store.commit('SET_FULL_INFO_ORDER', data);

            this.$alert('Ви вдало зберегли чернетку!', '', 'error');

            return true;
          }

          this.$alert('При збереженні виникла проблема, спробуйте знову!', '', 'error');
        });
      }
    },
    submitNextStep(){
      this.submitCheck = true;
      if (this.$v.$invalid) {
        this.scrollToErrors();
        return false;
      }
      let orderData = this.getOrderData();

      let orderDraft = orderData.orderDraft;
      let data = orderData.data;

      this.updateClientData(orderDraft);

      if (orderDraft) {
        saveOrder(orderDraft).then(response => {
          let dateText = 'Дата народження';
          if(this.orderData?.requestData?.customerType == 2){
            dateText = 'Дата створення';
          }
          if(response?.data?.data[0]?.status ==  'sanctioned'){
            this.$alert(
              `<div class="sanctions-alert-content">
                             <p>Данного клієнта знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>${dateText}:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
              'Санкції!',
              {
                dangerouslyUseHTMLString: true,
                type: 'error',
                customClass: 'sanctions-alert'
              }
            );
            return false;
          }
          if(response?.data?.data[0]?.status ==  'possible_match'){
            this.$alert(
              `<div class="sanctions-alert-content">
                             <p>Данного клієнта вірогідно знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>${dateText}:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
              'Санкції!',
              {
                dangerouslyUseHTMLString: true,
                type: 'error',
                customClass: 'sanctions-alert'
              }
            );
            return false;
          }

          if (response?.data?.data[0]?.statusId === 1) {
            data.orderId = response?.data?.data[0]?.id;
            this.orderId  = response?.data?.data[0]?.id;
            data.customer.documentation.type = orderDraft.customer.documentation.type;
            this.orderData.requestData.cityInfo = this.cityRegistration ? JSON.parse(JSON.stringify(this.cityRegistration)) : {};
            this.orderRequestData.cityInfo =  this.cityRegistration ? JSON.parse(JSON.stringify(this.cityRegistration)) : {};
            delete data.statusId;

            data.otpFlags = {
              otpStatus: true, // true - Включить отправку ОТР - кода
              confirmOtpStatus: false, // true - OTP код проверен успешно
              sentOtpPass: false, // true - OTP код был отправлен mail/viber/sms
              sendingOtpError: false, // true - при отправке ОТР кода произошла ошибка
              submitOtpCheck: false, // true - была нажата кнопка отправки ОТР кода на проверку
              otpCodeValidate: true, // статус проверки ОТР кода true - прошел проверку, false - код неверный
              pandingOtpSending: false, // флаг для отображения прелоадера при отправке ОТР кода
              pandingOtpCheck: false, // флаг для отображения прелоадера при отправке ОТР кода на проверку
              otpPass: '', // ОТР кода
            };

            this.$store.commit('SET_FULL_INFO_ORDER', data);
            this.$router.push({ name: 'orderFinal' });
            this.hideAnimateModal();
            return true;
          }

          this.$alert('При оформленні виникла проблема, спробуйте знову!', '', 'error');
        });
      }
    },
    parseDate(dateStr){
      const [day, month, year] = dateStr.split('.');
      return new Date(`${year}-${month}-${day}`);
    },
    nextStep() {
      if(this.car.birthdayAt && this.userData.dateBirth && !['TRAILER'].includes(this.carType.group) && !this.excludeModules.includes(parseInt(this.orderData.offer.ex_id)) && this.descriptions.includes(parseInt(this.orderData.offer.ex_id))){
        const carDate = this.parseDate(this.car.birthdayAt);
        const userDate = this.parseDate(this.userData.dateBirth);
        if (userDate > carDate) {
          this.$alert('Дата нарождення страхувальника не може бути менша за мінімальну дату народження водія');
          return;
        }
      }

      this.submitCheck = true;
      if (this.$refs.documentsBlock.$v.$invalid) {
        this.scrollToErrors();
        return false;
      }
      if (this.$refs.documentsBlockPrivileges && this.$refs.documentsBlockPrivileges.$v.$invalid) {
        this.scrollToErrors();
        return false;
      }

      if (this.$v.$invalid) {
        console.log(this.$v);
        this.scrollToErrors();
        return false;
      }

      if(!this.checkInvalidCartype()){
        this.alertMessage = 'Пільгове страхування авто з об\'ємом понад 2500см3 заборонено. Поверніться на калькуляцію та оберіть тип страхувальника без пільги, або оберіть інше авто';
        $('#custom-alert-orderSteps').modal('show');
        return;
      }

      this.showCompinatePlatePopup(this.cityRegistration);
    },
    validateTaxNumber(tax_number, date) {
      let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
      let birthDate = moment(date, 'DD.MM.YYYY');

      return tax_numberDate.isSame(birthDate, 'year')
                && tax_numberDate.isSame(birthDate, 'month')
                && tax_numberDate.isSame(birthDate, 'day');
    },

    removeSpace: function(event){
      if(event.keyCode === 32){
        event.preventDefault();
      }
    },
    removeQuote: function(event){
      console.log('event.keyCode',event.keyCode);
      if(event.keyCode === 50 || event.keyCode === 222){
        event.preventDefault();
      }
    },
    hasError(name) {
      return this.errors[name] !== undefined;
    },

    getError(name) {
      if(this.hasError(name)) {
        return this.errors[name][0].replace(name, '');
      }

      return '';
    },
    isCarSelected() {
      if (this.car.number && this.car.brand && this.car.vin) {
        return true;
      }
      return false;
    },
    saveFillData(params){
      this.isfillData = true;
      this.showFillClientDataModal = false;
      this.fillFormFromClientData(params.selectPibInn, params.selectVehicle, params.selectDocument);
    },
    fillFormFromClientData(selectPibInn, selectVehicle, selectDocument) {
      this.clientId = selectPibInn.id;
      this.$store.commit('SET_CLIENT', selectPibInn.id);
      let fio =  selectPibInn.fio.split(' ');
      if (this.isLegalType) {
        this.userData.name = selectPibInn.fio;
        this.userData.dateBirth = null;
      }else{
        this.userData.surname = fio[0];
        this.userData.name = fio[1];
        this.userData.patronymic = fio[2];
        this.userData.dateBirth = moment(selectPibInn.date_of_birth, 'DD-MM-YYYY').format('DD.MM.YYYY');
      }

      this.userData.phone = selectPibInn.phone;
      this.userData.email = selectPibInn.email;

      if(selectDocument){
        const privBlock = this.$refs.documentsBlockPrivileges;
        if (this.requiresPrivilegeDocument && privBlock && privBlock.typeDocumentId === parseInt(selectDocument.document_id)) {
          this.userData.privilege = {};
          this.userData.privilege.type = selectDocument.document_id;
          this.userData.privilege.serial = selectDocument.serial;
          this.userData.privilege.number = selectDocument.number;
          this.userData.privilege.issuedBy = selectDocument.issued_by;
          this.userData.privilege.dateOfIssue = moment(selectDocument.date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY');
          this.userData.privilege.endDateOfIssue = (selectDocument.end_date_of_issue) ? moment(selectDocument.end_date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
        } else {
          this.userData.documentation.type = selectDocument.document_id;
          this.userData.documentation.serial = selectDocument.serial;
          this.userData.documentation.number = selectDocument.number;
          this.userData.documentation.issuedBy = selectDocument.issued_by;
          this.userData.documentation.dateOfIssue = moment(selectDocument.date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY');
          this.userData.documentation.endDateOfIssue = (selectDocument.end_date_of_issue) ? moment(selectDocument.end_date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
        }
      }

      this.userData.address.street = selectPibInn.street ? selectPibInn.street.trim() : null;
      this.userData.address.house = selectPibInn.house;
      this.userData.address.cityId = selectPibInn.city?.id || null;
      this.userData.address.cityObject = selectPibInn?.city || null;

      this.userData.address.number = selectPibInn.flat;
      this.cityСlient = selectPibInn.city;
      if (this.isLegalType) {
        this.userData.erdpyCode = selectPibInn.identification_number;
      }else{
        this.userData.identificationCode = selectPibInn.identification_number;
      }

      this.insuredsList = [];
      this.insuredsListByErdpyCode = [];
      if(selectVehicle){
        this.car.brand = selectVehicle.mark_name;
        this.car.number = selectVehicle.registration_number;
        this.car.year = selectVehicle.year;
        this.car.vin = selectVehicle.vin;
        this.car.withoutVin = selectVehicle.without_vin;
        this.car.cityId = selectVehicle.registration_place_id;
        this.cityRegistration = selectVehicle.registration_place;
        if (selectVehicle.additional_parameters) {
          this.car_additional_parameters = selectVehicle.additional_parameters;
        } else {
          this.car_additional_parameters = {
            capacity: null,
            kvt: null,
            numberOfSeats: null,
            ownWeight: null,
            totalWeight: null,
          };
        }
        this.setAutoCategoryType(selectVehicle.type);
        if(selectVehicle.mark_name){
          let foundBrand = this.carBrands.find((e) => {
            return e.name.toLowerCase() == selectVehicle.mark_name.toLowerCase();
          });
          if(!foundBrand){
            this.addNewCar(selectVehicle.mark_name, 'brand');
          }else{
            this.brandObj = foundBrand;
          }
        }

        if(selectVehicle.model_name){
          setTimeout(() => {
            this.car.model = selectVehicle.model_name;
            let foundModel = this.carModels.find((e) => {
              return e.name.toLowerCase() == selectVehicle.model_name.toLowerCase();
            });
            if(!foundModel){
              this.addNewCar(selectVehicle.model_name, 'model');
            }else{
              this.modelObj = foundModel;
            }
          }, 300);
        }
      }

      let fullInfoOrder = this.$store.state.osagoStore.fullInfoOrder;
      fullInfoOrder.customer = this.userData;
      fullInfoOrder.car = this.car;
      this.$store.commit('SET_FULL_INFO_ORDER', fullInfoOrder);

      this.isfillData = false;

    },

    fillClientData(){
      this.showFillClientDataModal = true;
    },
    hasMixedLayouts(str) {
      const latinPattern = /[a-zA-Z]/;
      const cyrillicPattern = /[а-яА-Я]/;
      const hasLatin = latinPattern.test(str);
      const hasCyrillic = cyrillicPattern.test(str);
      return hasLatin && hasCyrillic;
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.orders.osago{
  .el-button:focus, .el-button:hover {
    color: white;
    border-color: #FFAD3D;
    background-color: #FFAD3D;
    opacity: 0.8;
  }
}
.sanctions-alert .el-message-box__message {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
}
.orders h3 {
  margin-bottom: 4px;
}
.icon.red {
  filter: brightness(0) saturate(100%) invert(15%) sepia(98%) saturate(7344%) hue-rotate(357deg) brightness(102%) contrast(108%);
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: inherit;
  color: #8f8f8f !important;
}
</style>
